export const newpostbases = {
    "\u2013a|\u2013ar|\u2013aa|+a|+aar[V\u2192V]": {
        "exp": "\u2013a|\u2013ar|\u2013aa|+a|+aar[V\u2192V]",
        "exp_display": "+a|+aar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "repeatedly",
        "gen_preverb": "repeatedly",
        "past_preverb": "repeatedly",
        "inf_preverb": "repeatedly",
        "ger_preverb": "repeatedly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-a-|-ar-|-aa-|+a-|+aar-",
            0
        ]
    },
    "+`(g)aqe[V\u2192V]": {
        "exp": "+`(g)aqe[V\u2192V]",
        "exp_display": "+`(g)aqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "repeatedly",
        "gen_preverb": "repeatedly",
        "past_preverb": "repeatedly",
        "inf_preverb": "repeatedly",
        "ger_preverb": "repeatedly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+'(g)aqe-",
            0
        ]
    },
    "+`(g)ar(ar)[V\u2192V]": {
        "exp": "+`(g)ar(ar)[V\u2192V]",
        "exp_display": "+`(g)ar(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "just barely",
        "gen_preverb": "just barely",
        "past_preverb": "just barely",
        "inf_preverb": "just barely",
        "ger_preverb": "just barely",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+'(g)ar(ar)-",
            2
        ]
    },
    "@+(g)ar(ar)te\u00b9[V\u2192V]": {
        "exp": "@+(g)ar(ar)te\u00b9[V\u2192V]",
        "exp_display": "@+\u2013`(g)ar(ar)te",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "suddenly",
        "gen_preverb": "suddenly",
        "past_preverb": "suddenly",
        "inf_preverb": "suddenly",
        "ger_preverb": "suddenly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@+(g)ar(ar)te\u00b9-",
            0
        ]
    },
    "+`(g)arkau[V\u2192V]": {
        "exp": "+`(g)arkau[V\u2192V]",
        "exp_display": "+`(g)arkau",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "will eventually",
        "gen_preverb": "will eventually",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "did not eventually",
        "past_preverb_after": "i",
        "inf_preverb": "eventually (in the future)",
        "inf_preverb_after": "i",
        "ger_preverb": "eventually (in the future)",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "+'(g)arkau-",
            0
        ]
    },
    "+`(g)arkaunrir[V\u2192V]": {
        "exp": "+`(g)arkaunrir[V\u2192V]",
        "exp_display": "+`(g)arkaunrir",
        "type": "VV",
        "tense": "future",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "now unable to",
        "gen_preverb": "now unable to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be now unable to",
        "inf_preverb_after": "i",
        "ger_preverb": "being able to now",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+'(g)arkaunrir-",
            0
        ]
    },
    "+aur(ar)[V\u2192V]": {
        "exp": "+aur(ar)[V\u2192V]",
        "exp_display": "+aur(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "continuing (over a period of time) to",
        "gen_preverb": "continuing (over a period of time) to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "continue (over a period of time) to",
        "inf_preverb_after": "i",
        "ger_preverb": "continuing (over a period of time) to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+aur(ar)-",
            0
        ]
    },
    "@~+caar(ar)[V\u2192V]": {
        "exp": "@~+caar(ar)[V\u2192V]",
        "exp_display": "@\u2074~+caar(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "endeavoring to",
        "gen_preverb": "endeavoring to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "endeavor to",
        "inf_preverb_after": "i",
        "ger_preverb": "endeavoring to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+caar(ar)-",
            0
        ]
    },
    "+(s)ciigali[V\u2192V]": {
        "exp": "+(s)ciigali[V\u2192V]",
        "exp_display": "+(s)ciigali",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "no longer able to",
        "gen_preverb": "no longer able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be no longer able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being no longer able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+(s)ciigali-,+(s)ciigalli-",
            0
        ]
    },
    "+(s)ciigalli[V\u2192V]": {
        "exp": "+(s)ciigalli[V\u2192V]",
        "exp_display": "+(s)ciigalli",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "no longer able to",
        "gen_preverb": "no longer able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be no longer able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being no longer able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+(s)ciigali-,+(s)ciigalli-",
            1
        ]
    },
    "+(s)ciigate[V\u2192V]": {
        "exp": "+(s)ciigate[V\u2192V]",
        "exp_display": "+(s)ciigate\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "not able to",
        "gen_preverb": "not able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be not able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being not able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+(s)ciigate-",
            0
        ]
    },
    "\u2013cilli[V\u2192V]": {
        "exp": "\u2013cilli[V\u2192V]",
        "exp_display": "\u2013cilli",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "appears to have been",
        "gen_preverb": "appears to have been",
        "gen_preverb_after": "g",
        "was": false,
        "past_preverb": "appeared to have been",
        "past_preverb_after": "g",
        "inf_preverb": "appear to have been",
        "inf_preverb_after": "g",
        "ger_preverb": "appearing to have been",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-cilli-",
            0
        ]
    },
    "+ciqe|@ciiqe[V\u2192V]": {
        "exp": "+ciqe|@ciiqe[V\u2192V]",
        "exp_display": "+ciqe|@\u2075ciiqe",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "will",
        "gen_preverb": "will",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "(in the future)",
        "past_preverb_after": "gen",
        "inf_preverb": "(in the future)",
        "inf_preverb_after": "i",
        "ger_preverb": "(in the future)",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "+ciqe-|@ciiqe-",
            0
        ]
    },
    "+ciqiar|@ciiqiar[V\u2192V]": {
        "exp": "+ciqiar|@ciiqiar[V\u2192V]",
        "exp_display": "+ciqiar|@\u2075ciiqiar",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "about to",
        "gen_preverb": "about to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be about to",
        "inf_preverb_after": "i",
        "ger_preverb": "being about to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+ciqiar-|@ciiqiar-",
            0
        ]
    },
    "@~+cir\u00b9[V\u2192V]": {
        "exp": "@~+cir\u00b9[V\u2192V]",
        "exp_display": "@\u2075~+cir",
        "type": "VV",
        "tense": "past",
        "subj": "",
        "is": false,
        "has": false,
        "description": "",
        "gen_preverb": "",
        "gen_preverb_after": "",
        "was": false,
        "past_preverb": "",
        "past_preverb_after": "",
        "inf_preverb": "",
        "inf_preverb_after": "i",
        "ger_preverb": "",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+cir\u00b9-",
            0
        ]
    },
    "+(s)cir\u00b2[V\u2192V]": {
        "exp": "+(s)cir\u00b2[V\u2192V]",
        "exp_display": "+(s)cir",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "been (detrimentally)",
        "gen_preverb": "been (detrimentally)",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had been (detrimentally)",
        "past_preverb_after": "pp",
        "inf_preverb": "have been (detrimentally)",
        "inf_preverb_after": "pp",
        "ger_preverb": "having been (detrimentally)",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "+(s)cir\u00b2-",
            0
        ]
    },
    "+(s)ciryar[V\u2192V]": {
        "exp": "+(s)ciryar[V\u2192V]",
        "exp_display": "+(s)ciryar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "easily",
        "gen_preverb": "easily",
        "gen_preverb_after": "pp",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "pp",
        "inf_preverb": "be easily",
        "inf_preverb_after": "pp",
        "ger_preverb": "being easily",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "+(s)ciryar-",
            0
        ]
    },
    "+cite\u00b2[V\u2192V]": {
        "exp": "+cite\u00b2[V\u2192V]",
        "exp_display": "+cite\u00b0",
        "type": "VV",
        "subj": "it",
        "is": false,
        "has": false,
        "description": "has the quality of",
        "gen_preverb": "has the quality of",
        "gen_preverb_after": "g",
        "was": false,
        "past_preverb": "had the quality of",
        "past_preverb_after": "g",
        "inf_preverb": "have the quality of",
        "inf_preverb_after": "g",
        "ger_preverb": "having the quality of",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "+cite\u00b2-",
            1
        ]
    },
    "+(s)ciur[V\u2192V]": {
        "exp": "+(s)ciur[V\u2192V]",
        "exp_display": "+(s)ciur",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "been (detrimentally)",
        "gen_preverb": "been (detrimentally)",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had been (detrimentally)",
        "past_preverb_after": "pp",
        "inf_preverb": "have been (detrimentally)",
        "inf_preverb_after": "pp",
        "ger_preverb": "having been (detrimentally)",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "+(s)ciur-",
            0
        ]
    },
    "\u2013curlag[V\u2192V]": {
        "exp": "\u2013curlag[V\u2192V]",
        "exp_display": "\u2013curlag",
        "type": "VV",
        "description": "with unsatisfactory results",
        "postverb": "with unsatisfactory results",
        "match_case": true,
        "keylookup": [
            "-curlak,-curlag-",
            0
        ]
    },
    "@~+(ng)iinar[V\u2192V]": {
        "exp": "@~+(ng)iinar[V\u2192V]",
        "exp_display": "@\u00b2~+(ng)iinar",
        "type": "VV",
        "description": "more and more",
        "postverb": "more and more",
        "match_case": true,
        "keylookup": [
            "@~+(ng)iinar-",
            0
        ]
    },
    ":(ng)illiqe[V\u2192V]": {
        "exp": "%:(ng)illiqe[V\u2192V]",
        "exp_display": "%:(ng)illiqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "suffering from the lack of",
        "gen_preverb": "suffering from the lack of",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "suffer from the lack of",
        "inf_preverb_after": "g",
        "ger_preverb": "suffering from the lack of",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            ":(ng)illiqe-",
            1
        ]
    },
    "\u2013inar[V\u2192V]": {
        "exp": "\u2013inar[V\u2192V]",
        "exp_display": "\u2013inar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "finally",
        "gen_preverb": "finally",
        "past_preverb": "finally",
        "inf_preverb": "finally",
        "ger_preverb": "finally",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-inar-",
            0
        ]
    },
    ":(ng)ite\u00b9[V\u2192V]": {
        "exp": "%:(ng)ite\u00b9[V\u2192V]",
        "exp_display": "%:(ng)ite\u00b0",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "lacks",
        "gen_preverb": "lacks",
        "gen_preverb_after": "g",
        "was": false,
        "past_preverb": "lacked",
        "past_preverb_after": "g",
        "inf_preverb": "lack",
        "inf_preverb_after": "g",
        "ger_preverb": "lacking",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            ":(ng)ite\u00b9-",
            1
        ]
    },
    "+kanir[V\u2192V]": {
        "exp": "+kanir[V\u2192V]",
        "exp_display": "+kanir",
        "type": "VV",
        "description": "more with greater intensity",
        "postverb": "more with greater intensity",
        "match_case": true,
        "keylookup": [
            "+kanir-",
            0
        ]
    },
    "+kanir(ar)[V\u2192V]": {
        "exp": "+kanir(ar)[V\u2192V]",
        "exp_display": "+kanir(ar)",
        "type": "VV",
        "description": "more and more, with greater intensity",
        "postverb": "more and more, with greater intensity",
        "match_case": true,
        "keylookup": [
            "+kanir(ar)-",
            0
        ]
    },
    "\u2013@kaunrir[V\u2192V]": {
        "exp": "\u2013@kaunrir[V\u2192V]",
        "exp_display": "\u2013@\u2074k\u0332aunrir",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "unable to (due to an inhibiting factor)",
        "gen_preverb": "unable to (due to an inhibiting factor)",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be unable to (due to an inhibiting factor)",
        "inf_preverb_after": "i",
        "ger_preverb": "being unable to (due to an inhibiting factor)",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-@kaunrir-",
            0
        ]
    },
    "\u2013knig[V\u2192V]": {
        "exp": "\u2013knig[V\u2192V]",
        "exp_display": "\u2013knig",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "suddenly (in motion)",
        "gen_preverb": "suddenly (in motion)",
        "past_preverb": "suddenly (in motion)",
        "inf_preverb": "suddenly (in motion)",
        "ger_preverb": "suddenly (in motion)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-knig-",
            0
        ]
    },
    "\u2013ksaar(ar)[V\u2192V]": {
        "exp": "\u2013ksaar(ar)[V\u2192V]",
        "exp_display": "\u2013ksaar(ar)",
        "type": "VV",
        "description": "in a small and unnoticeable way",
        "postverb": "in a small and unnoticeable way",
        "match_case": true,
        "keylookup": [
            "-ksaar(ar)-",
            0
        ]
    },
    "\u2013ksaite[V\u2192V]": {
        "exp": "\u2013ksaite[V\u2192V]",
        "exp_display": "\u2013k\u0332saite\u00b0",
        "type": "VV",
        "tense": "past",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": true,
        "description": "not",
        "gen_preverb": "not",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had not",
        "past_preverb_after": "pp",
        "inf_preverb": "have not",
        "inf_preverb_after": "pp",
        "ger_preverb": "having not",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-ksaite-",
            0
        ]
    },
    "\u2013ksaitelar[V\u2192V]": {
        "exp": "\u2013ksaitelar[V\u2192V]",
        "exp_display": "\u2013k\u0332saitelar",
        "type": "VV",
        "tense": "past",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": true,
        "description": "never",
        "gen_preverb": "never",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had never",
        "past_preverb_after": "pp",
        "inf_preverb": "have never",
        "inf_preverb_after": "pp",
        "ger_preverb": "having never",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-ksaitelar-,-ksaitlar-",
            0
        ]
    },
    "\u2013ksaitlar[V\u2192V]": {
        "exp": "\u2013ksaitlar[V\u2192V]",
        "exp_display": "\u2013k\u0332saitlar",
        "type": "VV",
        "tense": "past",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": true,
        "description": "never",
        "gen_preverb": "never",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had never",
        "past_preverb_after": "pp",
        "inf_preverb": "have never",
        "inf_preverb_after": "pp",
        "ger_preverb": "having never",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-ksaitelar-,-ksaitlar-",
            1
        ]
    },
    "\u2013ksuar(ar)[V\u2192V]": {
        "exp": "\u2013ksuar(ar)[V\u2192V]",
        "exp_display": "\u2013ksuar(ar)",
        "type": "VV",
        "description": "in a small and not very noticeable way",
        "postverb": "in a small and not very noticeable way",
        "match_case": true,
        "keylookup": [
            "-ksuar(ar)-,-ksuar(ar)-",
            1
        ]
    },
    "\u2013kugte[V\u2192V]": {
        "exp": "\u2013kugte[V\u2192V]",
        "exp_display": "\u2013kugte",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "about to",
        "gen_preverb": "about to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be about to",
        "inf_preverb_after": "i",
        "ger_preverb": "being about to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-kugte-",
            0
        ]
    },
    "\u2013kuna[V\u2192V]": {
        "exp": "\u2013kuna[V\u2192V]",
        "exp_display": "\u2013kuna",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "planning to",
        "gen_preverb": "planning to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "plan to",
        "inf_preverb_after": "i",
        "ger_preverb": "planning to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-kuna-",
            0
        ]
    },
    "\u2013kunayaaqe[V\u2192V]": {
        "exp": "\u2013kunayaaqe[V\u2192V]",
        "exp_display": "\u2013kunayaaqe",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "considering",
        "gen_preverb": "considering",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "consider",
        "inf_preverb_after": "g",
        "ger_preverb": "considering",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-kunayaaqe-",
            0
        ]
    },
    "\u2013kutag[V\u2192V]": {
        "exp": "\u2013kutag[V\u2192V]",
        "exp_display": "\u2013kutag",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "probably",
        "gen_preverb": "probably",
        "past_preverb": "probably",
        "inf_preverb": "probably",
        "ger_preverb": "probably",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-kutag-",
            0
        ]
    },
    "\u2013kutar(ar)[V\u2192V]": {
        "exp": "\u2013kutar(ar)[V\u2192V]",
        "exp_display": "\u2013kutar(ar)",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "planning to",
        "gen_preverb": "planning to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "plan to",
        "inf_preverb_after": "i",
        "ger_preverb": "planning to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-kutar(ar)-",
            0
        ]
    },
    "\u2013laag[V\u2192V]": {
        "exp": "\u2013laag[V\u2192V]",
        "exp_display": "\u2013laag",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "quickly",
        "gen_preverb": "quickly",
        "past_preverb": "quickly",
        "inf_preverb": "quickly",
        "ger_preverb": "quickly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-laag-",
            0
        ]
    },
    "~+lallru[V\u2192V]": {
        "exp": "~+lallru[V\u2192V]",
        "exp_display": "~+lallru",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "formerly regularly",
        "gen_preverb": "formerly regularly",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had formerly regularly",
        "past_preverb_after": "pp",
        "inf_preverb": "have formerly regularly",
        "inf_preverb_after": "pp",
        "ger_preverb": "having formerly regularly",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "~+lallru-,@~+lallru-,-lallru-",
            0
        ]
    },
    "@~+lallru[V\u2192V]": {
        "exp": "@~+lallru[V\u2192V]",
        "exp_display": "@\u02e1~+lallru",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "formerly regularly",
        "gen_preverb": "formerly regularly",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had formerly regularly",
        "past_preverb_after": "pp",
        "inf_preverb": "have formerly regularly",
        "inf_preverb_after": "pp",
        "ger_preverb": "having formerly regularly",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "~+lallru-,@~+lallru-,-lallru-",
            1
        ]
    },
    "\u2013lallru[V\u2192V]": {
        "exp": "\u2013lallru[V\u2192V]",
        "exp_display": "\u2013lallru",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "formerly regularly",
        "gen_preverb": "formerly regularly",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had formerly regularly",
        "past_preverb_after": "pp",
        "inf_preverb": "have formerly regularly",
        "inf_preverb_after": "pp",
        "ger_preverb": "having formerly regularly",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "~+lallru-,@~+lallru-,-lallru-",
            2
        ]
    },
    "~+lar[V\u2192V]": {
        "exp": "~+lar[V\u2192V]",
        "exp_display": "~+lar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "regularly",
        "gen_preverb": "regularly",
        "past_preverb": "regularly",
        "inf_preverb": "regularly",
        "ger_preverb": "regularly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "~+lar-,@~+lar-,-lar-",
            0
        ]
    },
    "@~+lar[V\u2192V]": {
        "exp": "@~+lar[V\u2192V]",
        "exp_display": "@\u02e1~+lar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "regularly",
        "gen_preverb": "regularly",
        "past_preverb": "regularly",
        "inf_preverb": "regularly",
        "ger_preverb": "regularly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "~+lar-,@~+lar-,-lar-",
            1
        ]
    },
    "\u2013lar[V\u2192V]": {
        "exp": "\u2013lar[V\u2192V]",
        "exp_display": "\u2013lar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "regularly",
        "gen_preverb": "regularly",
        "past_preverb": "regularly",
        "inf_preverb": "regularly",
        "ger_preverb": "regularly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "~+lar-,@~+lar-,-lar-",
            2
        ]
    },
    "~+laryaaqe[V\u2192V]": {
        "exp": "~+laryaaqe[V\u2192V]",
        "exp_display": "~+laryaaqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "usually (though not at this time)",
        "gen_preverb": "usually (though not at this time)",
        "past_preverb": "usually (though not at this time)",
        "inf_preverb": "usually (though not at this time)",
        "ger_preverb": "usually (though not at this time)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "~+laryaaqe-,@~+laryaaqe-,-laryaaqe-",
            0
        ]
    },
    "@~+laryaaqe[V\u2192V]": {
        "exp": "@~+laryaaqe[V\u2192V]",
        "exp_display": "@\u02e1~+laryaaqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "usually (though not at this time)",
        "gen_preverb": "usually (though not at this time)",
        "past_preverb": "usually (though not at this time)",
        "inf_preverb": "usually (though not at this time)",
        "ger_preverb": "usually (though not at this time)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "~+laryaaqe-,@~+laryaaqe-,-laryaaqe-",
            1
        ]
    },
    "\u2013laryaaqe[V\u2192V]": {
        "exp": "\u2013laryaaqe[V\u2192V]",
        "exp_display": "\u2013laryaaqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "usually (though not at this time)",
        "gen_preverb": "usually (though not at this time)",
        "past_preverb": "usually (though not at this time)",
        "inf_preverb": "usually (though not at this time)",
        "ger_preverb": "usually (though not at this time)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "~+laryaaqe-,@~+laryaaqe-,-laryaaqe-",
            2
        ]
    },
    "\u2013ler[V\u2192V]": {
        "exp": "\u2013ler[V\u2192V]",
        "exp_display": "\u2013ler",
        "type": "VV",
        "description": "suddenly and willfully",
        "postverb": "suddenly and willfully",
        "match_case": true,
        "keylookup": [
            "-ler-,~+ler-",
            0
        ]
    },
    "~+ler[V\u2192V]": {
        "exp": "~+ler[V\u2192V]",
        "exp_display": "~+ler",
        "type": "VV",
        "description": "suddenly and willfully",
        "postverb": "suddenly and willfully",
        "match_case": true,
        "keylookup": [
            "-ler-,~+ler-",
            1
        ]
    },
    "\u2013leryag[V\u2192V]": {
        "exp": "\u2013leryag[V\u2192V]",
        "exp_display": "\u2013leryag",
        "type": "VV",
        "description": "abruptly",
        "postverb": "abruptly",
        "match_case": true,
        "keylookup": [
            "-leryag-,~+leryag-",
            0
        ]
    },
    "~+leryag[V\u2192V]": {
        "exp": "~+leryag[V\u2192V]",
        "exp_display": "~+leryag",
        "type": "VV",
        "description": "abruptly",
        "postverb": "abruptly",
        "match_case": true,
        "keylookup": [
            "-leryag-,~+leryag-",
            1
        ]
    },
    "\u2013lgu[V\u2192V]": {
        "exp": "\u2013lgu[V\u2192V]",
        "exp_display": "\u2013lgu",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "always",
        "gen_preverb": "always",
        "past_preverb": "always",
        "inf_preverb": "always",
        "ger_preverb": "always",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-lgu-",
            0
        ]
    },
    "\u2013lguir[V\u2192V]": {
        "exp": "\u2013lguir[V\u2192V]",
        "exp_display": "\u2013lguir",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "stopped being able to",
        "gen_preverb": "stopped being able to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "had stopped being able to",
        "past_preverb_after": "i",
        "inf_preverb": "have stopped being able to",
        "inf_preverb_after": "i",
        "ger_preverb": "having stopped being able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-lguir-",
            0
        ]
    },
    "\u2013lguirute[V\u2192V]": {
        "exp": "\u2013lguirute[V\u2192V]",
        "exp_display": "\u2013lguirute",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "no longer able to",
        "gen_preverb": "no longer able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be no longer able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being no longer able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-lguirute-",
            0
        ]
    },
    "\u2013lguite[V\u2192V]": {
        "exp": "\u2013lguite[V\u2192V]",
        "exp_display": "\u2013lguite\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "unable to",
        "gen_preverb": "unable to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be unable to",
        "inf_preverb_after": "i",
        "ger_preverb": "being unable to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-lguite-",
            0
        ]
    },
    "\u2013lguri[V\u2192V]": {
        "exp": "\u2013lguri[V\u2192V]",
        "exp_display": "\u2013lguri",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "became able to",
        "gen_preverb": "became able to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "had become able to",
        "past_preverb_after": "i",
        "inf_preverb": "have become able to",
        "inf_preverb_after": "i",
        "ger_preverb": "having become able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-lguri-",
            0
        ]
    },
    "\u2013\u2013liyar[V\u2192V]": {
        "exp": "\u2013\u2013liyar[V\u2192V]",
        "exp_display": "\u2013\u2013liyar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "going to participate in",
        "gen_preverb": "going to participate in",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "go participate in",
        "inf_preverb_after": "g",
        "ger_preverb": "going to participate in",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-liyar-,-liar-",
            2
        ]
    },
    "\u2013liar[V\u2192V]": {
        "exp": "\u2013liar[V\u2192V]",
        "exp_display": "\u2013liar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "going to participate in",
        "gen_preverb": "going to participate in",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "go participate in",
        "inf_preverb_after": "g",
        "ger_preverb": "going to participate in",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-liyar-,-liar-",
            3
        ]
    },
    "\u2013lkia[V\u2192V]": {
        "exp": "\u2013lkia[V\u2192V]",
        "exp_display": "\u2013lkia",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "giving evidence of",
        "gen_preverb": "giving evidence of",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "give evidence of",
        "inf_preverb_after": "g",
        "ger_preverb": "giving evidence of",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-lkia-",
            1
        ]
    },
    "\u2013llag[V\u2192V]": {
        "exp": "\u2013llag[V\u2192V]",
        "exp_display": "\u2013llag",
        "type": "VV",
        "description": "suddenly and surprisingly",
        "postverb": "suddenly and surprisingly",
        "match_case": true,
        "keylookup": [
            "-llag-",
            0
        ]
    },
    "\u2013llgu[V\u2192V]": {
        "exp": "\u2013llgu[V\u2192V]",
        "exp_display": "\u2013llgu",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "good at",
        "gen_preverb": "good at",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "be good at",
        "inf_preverb_after": "g",
        "ger_preverb": "being good at",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-llgu-",
            0
        ]
    },
    "\u2013lli[V\u2192V]": {
        "exp": "\u2013lli[V\u2192V]",
        "exp_display": "\u2013lli",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "maybe",
        "gen_preverb": "maybe",
        "past_preverb": "maybe",
        "inf_preverb": "maybe",
        "ger_preverb": "maybe",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-lli-",
            0
        ]
    },
    "\u2013llini[V\u2192V]": {
        "exp": "\u2013llini[V\u2192V]",
        "exp_display": "\u2013llini",
        "type": "VV",
        "description": "evidently",
        "postverb": "evidently",
        "match_case": true,
        "keylookup": [
            "-llini-",
            0
        ]
    },
    "\u2013llru\u00b9[V\u2192V]": {
        "exp": "\u2013llru\u00b9[V\u2192V]",
        "exp_display": "\u2013llru",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "",
        "gen_preverb": "",
        "gen_preverb_after": "p",
        "was": false,
        "past_preverb": "",
        "past_preverb_after": "p",
        "inf_preverb": "(in the past)",
        "inf_preverb_after": "i",
        "ger_preverb": "(in the past)",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-llru\u00b9-",
            0
        ]
    },
    "\u2013llrunrite[V\u2192V]": {
        "exp": "\u2013llrunrite[V\u2192V]",
        "exp_display": "\u2013llrunrite\u00b0",
        "type": "VV",
        "tense": "past",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": true,
        "description": "not",
        "gen_preverb": "not",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had not",
        "past_preverb_after": "pp",
        "inf_preverb": "have not",
        "inf_preverb_after": "pp",
        "ger_preverb": "having not",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-llrunrite-",
            0
        ]
    },
    "\u2013llrurte[V\u2192V]": {
        "exp": "\u2013llrurte[V\u2192V]",
        "exp_display": "\u2013llrurte",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "already",
        "gen_preverb": "already",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had already",
        "past_preverb_after": "pp",
        "inf_preverb": "have already",
        "inf_preverb_after": "pp",
        "ger_preverb": "having already",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-llrurte-",
            0
        ]
    },
    "\u2013llugtur[V\u2192V]": {
        "exp": "\u2013llugtur[V\u2192V]",
        "exp_display": "\u2013llugtur",
        "type": "VV",
        "description": "quickly",
        "postverb": "quickly",
        "match_case": true,
        "keylookup": [
            "-llugtur-",
            0
        ]
    },
    "\u2013lngu[V\u2192V]": {
        "exp": "\u2013lngu[V\u2192V]",
        "exp_display": "\u2013lngu",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "tired of",
        "gen_preverb": "tired of",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "be tired of",
        "inf_preverb_after": "g",
        "ger_preverb": "being tired of",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-lngu-",
            0
        ]
    },
    "\u2013luaqar[V\u2192V]": {
        "exp": "\u2013luaqar[V\u2192V]",
        "exp_display": "\u2013luaqar",
        "type": "VV",
        "description": "well",
        "postverb": "well",
        "match_case": true,
        "keylookup": [
            "-luaqar-",
            0
        ]
    },
    ":(u|i)ma[V\u2192V]": {
        "exp": "%:(u|i)ma[V\u2192V]",
        "exp_display": "%:(u|i)ma",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "in a state of having",
        "gen_preverb": "in a state of having",
        "gen_preverb_after": "p",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "p",
        "inf_preverb": "be in a state of",
        "inf_preverb_after": "g",
        "ger_preverb": "being in a state of",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            ":(u|i)ma-",
            0
        ]
    },
    ":(u|i)maar[V\u2192V]": {
        "exp": "%:(u|i)maar[V\u2192V]",
        "exp_display": "%:(u|i)maar",
        "type": "VV",
        "description": "for a short duration or without making a big deal of it",
        "postverb": "for a short duration or without making a big deal of it",
        "match_case": true,
        "keylookup": [
            ":(u|i)maar-",
            0
        ]
    },
    ":(u|i)maar(ar)[V\u2192V]": {
        "exp": "%:(u|i)maar(ar)[V\u2192V]",
        "exp_display": "%:(u|i)maar(ar)",
        "type": "VV",
        "description": "slowly",
        "postverb": "slowly",
        "match_case": true,
        "keylookup": [
            ":(u|i)maar(ar)-",
            0
        ]
    },
    ":(u|i)mari[V\u2192V]": {
        "exp": "%:(u|i)mari[V\u2192V]",
        "exp_display": "%:(u|i)mari",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "already",
        "gen_preverb": "already",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had already",
        "past_preverb_after": "pp",
        "inf_preverb": "have already",
        "inf_preverb_after": "pp",
        "ger_preverb": "having already",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            ":(u|i)mari-",
            0
        ]
    },
    "\u2013mcaugar[V\u2192V]": {
        "exp": "\u2013mcaugar[V\u2192V]",
        "exp_display": "\u2013mcaugar",
        "type": "VV",
        "description": "in a small way",
        "postverb": "in a small way",
        "match_case": true,
        "keylookup": [
            "-mcaugar-",
            0
        ]
    },
    "\u2013mciur(ar)[V\u2192V]": {
        "exp": "\u2013mciur(ar)[V\u2192V]",
        "exp_display": "\u2013mciur(ar)",
        "type": "VV",
        "description": "a little at a time",
        "postverb": "a little at a time",
        "match_case": true,
        "keylookup": [
            "-mciur(ar)-",
            0
        ]
    },
    "\u2013mcuar(ar)[V\u2192V]": {
        "exp": "\u2013mcuar(ar)[V\u2192V]",
        "exp_display": "\u2013mcuar(ar)",
        "type": "VV",
        "description": "a little",
        "postverb": "a little",
        "match_case": true,
        "keylookup": [
            "-mcuar(ar)-",
            0
        ]
    },
    "\u2013mcugte[V\u2192V]": {
        "exp": "\u2013mcugte[V\u2192V]",
        "exp_display": "\u2013mcugte",
        "type": "VV",
        "description": "to a small degree",
        "postverb": "to a small degree",
        "match_case": true,
        "keylookup": [
            "-mcugte-,-mssugte-,-myugte-",
            1
        ]
    },
    "\u2013mssugte[V\u2192V]": {
        "exp": "\u2013mssugte[V\u2192V]",
        "exp_display": "\u2013mssugte",
        "type": "VV",
        "description": "in a small way",
        "postverb": "in a small way",
        "match_case": true,
        "keylookup": [
            "-mssugte-",
            1
        ]
    },
    "@~+mi[V\u2192V]": {
        "exp": "@~+mi[V\u2192V]",
        "exp_display": "@\u00b2~+mi",
        "type": "VV",
        "description": "also",
        "postverb": "also",
        "match_case": true,
        "keylookup": [
            "@~+mi-",
            0
        ]
    },
    "+milli[V\u2192V]": {
        "exp": "+milli[V\u2192V]",
        "exp_display": "+milli",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "probably also",
        "gen_preverb": "probably also",
        "past_preverb": "probably also",
        "inf_preverb": "probably also",
        "ger_preverb": "probably also",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+milli-",
            0
        ]
    },
    "\u2013mli[V\u2192V]": {
        "exp": "\u2013mli[V\u2192V]",
        "exp_display": "\u2013mli",
        "type": "VV",
        "description": "casually",
        "postverb": "casually",
        "match_case": true,
        "keylookup": [
            "-mli-",
            0
        ]
    },
    "\u2013mssag[V\u2192V]": {
        "exp": "\u2013mssag[V\u2192V]",
        "exp_display": "\u2013mssag",
        "type": "VV",
        "description": "in a small way",
        "postverb": "in a small way",
        "match_case": true,
        "keylookup": [
            "-mssag-",
            0
        ]
    },
    "\u2013myugte[V\u2192V]": {
        "exp": "\u2013myugte[V\u2192V]",
        "exp_display": "\u2013myugte",
        "type": "VV",
        "description": "in a small way",
        "postverb": "in a small way",
        "match_case": true,
        "keylookup": [
            "-myugte-",
            0
        ]
    },
    "@~+naciar[V\u2192V]": {
        "exp": "@~+naciar[V\u2192V]",
        "exp_display": "@\u00b9~+naciar",
        "type": "VV",
        "description": "late",
        "postverb": "late",
        "match_case": true,
        "keylookup": [
            "@~+naciar-",
            0
        ]
    },
    "@~+nanrir[V\u2192V]": {
        "exp": "@~+nanrir[V\u2192V]",
        "exp_display": "@\u00b9~+nanrir",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "ceasing",
        "gen_preverb": "ceasing",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "cease",
        "inf_preverb_after": "g",
        "ger_preverb": "ceasing",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+nanrir-",
            0
        ]
    },
    "@~+naqsaaqe[V\u2192V]": {
        "exp": "@~+naqsaaqe[V\u2192V]",
        "exp_display": "@\u00b9~+naqsaaqe",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "now feasible to",
        "gen_preverb": "now feasible to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be now feasible to",
        "inf_preverb_after": "i",
        "ger_preverb": "being now feasible to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+naqsaaqe-",
            0
        ]
    },
    "@~+nari[V\u2192V]": {
        "exp": "@~+nari[V\u2192V]",
        "exp_display": "@\u00b9~+nari",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "time to",
        "gen_preverb": "time to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be time to",
        "inf_preverb_after": "i",
        "ger_preverb": "being time to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+nari-",
            0
        ]
    },
    "@~+naur[V\u2192V]": {
        "exp": "@~+naur[V\u2192V]",
        "exp_display": "@\u00b9~+naur",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "habitually",
        "gen_preverb": "habitually",
        "past_preverb": "habitually",
        "inf_preverb": "habitually",
        "ger_preverb": "habitually",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@~+naur-",
            0
        ]
    },
    "@\u2013nerkite[V\u2192V]": {
        "exp": "@\u2013nerkite[V\u2192V]",
        "exp_display": "@\u00b9\u2013nerkite\u00b0",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "habitually (only a little bit)",
        "gen_preverb": "habitually (only a little bit)",
        "past_preverb": "habitually (only a little bit)",
        "inf_preverb": "habitually (only a little bit)",
        "ger_preverb": "habitually (only a little bit)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@-nerkite-",
            0
        ]
    },
    "\u2013nerrar[V\u2192V]": {
        "exp": "\u2013nerrar[V\u2192V]",
        "exp_display": "\u2013nerrar",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "recently",
        "gen_preverb": "recently",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had recently",
        "past_preverb_after": "pp",
        "inf_preverb": "have recently",
        "inf_preverb_after": "pp",
        "ger_preverb": "having recently",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            3
        ]
    },
    "\u2013nerrar(ar)[V\u2192V]": {
        "exp": "\u2013nerrar(ar)[V\u2192V]",
        "exp_display": "\u2013nerrar(ar)",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "recently",
        "gen_preverb": "recently",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had recently",
        "past_preverb_after": "pp",
        "inf_preverb": "have recently",
        "inf_preverb_after": "pp",
        "ger_preverb": "having recently",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            4
        ]
    },
    "\u2013nerar(ar)[V\u2192V]": {
        "exp": "\u2013nerar(ar)[V\u2192V]",
        "exp_display": "\u2013nerar(ar)",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "recently",
        "gen_preverb": "recently",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had recently",
        "past_preverb_after": "pp",
        "inf_preverb": "have recently",
        "inf_preverb_after": "pp",
        "ger_preverb": "having recently",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            5
        ]
    },
    "@\u2013nerrlugte[V\u2192V]": {
        "exp": "@\u2013nerrlugte[V\u2192V]",
        "exp_display": "@\u00b9\u2013nerrlugte",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "having trouble with ^his^",
        "gen_preverb": "having trouble with ^his^",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "have trouble with ^his^",
        "inf_preverb_after": "g",
        "ger_preverb": "having trouble with ^his^",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@-nerrlugte-",
            0
        ]
    },
    "@\u2013nertu[V\u2192V]": {
        "exp": "@\u2013nertu[V\u2192V]",
        "exp_display": "@\u00b9\u2013nertu",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "habitually (a lot)",
        "gen_preverb": "habitually (a lot)",
        "past_preverb": "habitually (a lot)",
        "inf_preverb": "habitually (a lot)",
        "ger_preverb": "habitually (a lot)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@-nertu-",
            0
        ]
    },
    "@nga[V\u2192V]": {
        "exp": "@nga[V\u2192V]",
        "exp_display": "@nga",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": false,
        "has": true,
        "description": "been in a state of having",
        "gen_preverb": "been in a state of having",
        "gen_preverb_after": "pp",
        "was": false,
        "past_preverb": "had been in a state of having",
        "past_preverb_after": "pp",
        "inf_preverb": "be in a state of having",
        "inf_preverb_after": "pp",
        "ger_preverb": "being in a state of having",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "@nga-",
            0
        ]
    },
    "@~+ngair(ar)te[V\u2192V]": {
        "exp": "@~+ngair(ar)te[V\u2192V]",
        "exp_display": "@\u00b2~+ngair(ar)te",
        "type": "VV",
        "tense": "future",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "no longer going to",
        "gen_preverb": "no longer going to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be no longer going to",
        "inf_preverb_after": "i",
        "ger_preverb": "being no longer going to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+ngair(ar)te-",
            0
        ]
    },
    "@~+ngairute[V\u2192V]": {
        "exp": "@~+ngairute[V\u2192V]",
        "exp_display": "@\u00b2~+ngairute",
        "type": "VV",
        "tense": "future",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "will never again",
        "gen_preverb": "will never again",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "won't (again)",
        "past_preverb_after": "i",
        "inf_preverb": "not (in the future ever)",
        "inf_preverb_after": "i",
        "ger_preverb": "not (in the future ever)",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+ngairute-",
            0
        ]
    },
    "@~+ngaite[V\u2192V]": {
        "exp": "@~+ngaite[V\u2192V]",
        "exp_display": "@\u00b2~+ngaite\u00b0",
        "type": "VV",
        "tense": "future",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "will not",
        "gen_preverb": "will not",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "won't",
        "past_preverb_after": "i",
        "inf_preverb": "not (in the future)",
        "inf_preverb_after": "i",
        "ger_preverb": "not (in the future)",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+ngaite-",
            0
        ]
    },
    "@~+ngate[V\u2192V]": {
        "exp": "@~+ngate[V\u2192V]",
        "exp_display": "@\u00b2~+ngate\u00b0",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "seems to be",
        "gen_preverb": "seems to be",
        "gen_preverb_after": "g",
        "was": false,
        "past_preverb": "seemed to be",
        "past_preverb_after": "g",
        "inf_preverb": "seem to be",
        "inf_preverb_after": "g",
        "ger_preverb": "seeming to be",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+ngate-,+ngate-",
            1
        ]
    },
    "\u2013nge[V\u2192V]": {
        "exp": "\u2013nge[V\u2192V]",
        "exp_display": "\u2013nge",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "beginning to",
        "gen_preverb": "beginning to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "begin to",
        "inf_preverb_after": "i",
        "ger_preverb": "beginning to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-nge-",
            1
        ]
    },
    "@~+ngiate[V\u2192V]": {
        "exp": "@~+ngiate[V\u2192V]",
        "exp_display": "@\u00b2~+ngiate\u00b0",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "inept at",
        "gen_preverb": "inept at",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "be inept at",
        "inf_preverb_after": "g",
        "ger_preverb": "being inept at",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+ngiate-",
            0
        ]
    },
    "@~+ngig[V\u2192V]": {
        "exp": "@~+ngig[V\u2192V]",
        "exp_display": "@\u00b2~+ngig",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "adept at",
        "gen_preverb": "adept at",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "be adept at",
        "inf_preverb_after": "g",
        "ger_preverb": "being adept at",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+ngig-",
            0
        ]
    },
    "@~+nginar[V\u2192V]": {
        "exp": "@~+nginar[V\u2192V]",
        "exp_display": "@\u00b2~+nginar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "merely (with no attendant complications)",
        "gen_preverb": "merely (with no attendant complications)",
        "past_preverb": "merely (with no attendant complications)",
        "inf_preverb": "merely (with no attendant complications)",
        "ger_preverb": "merely (with no attendant complications)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@~+nginar-",
            0
        ]
    },
    "\u2013ngnagar[V\u2192V]": {
        "exp": "\u2013ngnagar[V\u2192V]",
        "exp_display": "\u2013ngnagar",
        "type": "VV",
        "description": "in an irritating way",
        "postverb": "in an irritating way",
        "match_case": true,
        "keylookup": [
            "-ngnagaq,-ngnagar-",
            1
        ]
    },
    "\u2013ngnaqe[V\u2192V]": {
        "exp": "\u2013ngnaqe[V\u2192V]",
        "exp_display": "\u2013ngnaqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "trying to",
        "gen_preverb": "trying to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "try to",
        "inf_preverb_after": "i",
        "ger_preverb": "trying to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-ngnaqe-",
            0
        ]
    },
    "\u2013ngnaqsaaqe[V\u2192V]": {
        "exp": "\u2013ngnaqsaaqe[V\u2192V]",
        "exp_display": "\u2013ngnaqsaaqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "trying unsuccessfully to",
        "gen_preverb": "trying unsuccessfully to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "try unsuccessfully to",
        "inf_preverb_after": "i",
        "ger_preverb": "trying unsuccessfully to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-ngnaqsaaqe-",
            0
        ]
    },
    "\u2013ngnatug[V\u2192V]": {
        "exp": "\u2013ngnatug[V\u2192V]",
        "exp_display": "\u2013ngnatug",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "trying hard to",
        "gen_preverb": "trying hard to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "try hard to",
        "inf_preverb_after": "i",
        "ger_preverb": "trying hard to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-ngnatug-",
            0
        ]
    },
    "@\u2013ngqa[V\u2192V]": {
        "exp": "@\u2013ngqa[V\u2192V]",
        "exp_display": "@\u2075\u2013ngqa",
        "type": "VV",
        "tense": "past",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "in a state of",
        "gen_preverb": "in a state of",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "be in a state of",
        "inf_preverb_after": "g",
        "ger_preverb": "being in a state of",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@-ngqa-",
            2
        ]
    },
    "\u2013ngssaar(ar)[V\u2192V]": {
        "exp": "\u2013ngssaar(ar)[V\u2192V]",
        "exp_display": "\u2013ngssaar(ar)",
        "type": "VV",
        "description": "secretively, unnoticeably",
        "postverb": "secretively, unnoticeably",
        "match_case": true,
        "keylookup": [
            "-ngssaar(aq*),-ngssaar(ar)-",
            1
        ]
    },
    "\u2013ngssag[V\u2192V]": {
        "exp": "\u2013ngssag[V\u2192V]",
        "exp_display": "\u2013ngssag",
        "type": "VV",
        "description": "to no particular end",
        "postverb": "to no particular end",
        "match_case": true,
        "keylookup": [
            "-ngssak,-ngssag-",
            0
        ]
    },
    "\u2013ngssi[V\u2192V]": {
        "exp": "\u2013ngssi[V\u2192V]",
        "exp_display": "\u2013ngssi",
        "type": "VV",
        "description": "to no particular end",
        "postverb": "to no particular end",
        "match_case": true,
        "keylookup": [
            "-ngssi-",
            0
        ]
    },
    "@~\u2013nguar[V\u2192V]": {
        "exp": "@~\u2013nguar[V\u2192V]",
        "exp_display": "@\u00b2~\u2013nguar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "pretending to",
        "gen_preverb": "pretending to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "pretend to",
        "inf_preverb_after": "i",
        "ger_preverb": "pretending to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-nguaq,@~-nguar-",
            1
        ]
    },
    "@~+niar[V\u2192V]": {
        "exp": "@~+niar[V\u2192V]",
        "exp_display": "@\u00b9~+niar",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "will (suggestion)",
        "gen_preverb": "will (suggestion)",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "(in the future, suggestion)",
        "inf_preverb_after": "i",
        "ger_preverb": "(in the future, suggestion)",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+niar-",
            0
        ]
    },
    "@~+niarar[V\u2192V]": {
        "exp": "@~+niarar[V\u2192V]",
        "exp_display": "@\u00b9~+niarar",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "soon going to",
        "gen_preverb": "soon going to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "soon be going",
        "inf_preverb_after": "g",
        "ger_preverb": "soon being going",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+niarar-",
            0
        ]
    },
    "\u2013nqegcaar(ar)[V\u2192V]": {
        "exp": "\u2013nqegcaar(ar)[V\u2192V]",
        "exp_display": "\u2013nqegcaar(ar)",
        "type": "VV",
        "description": "completely, thoroughly",
        "postverb": "completely, thoroughly",
        "match_case": true,
        "keylookup": [
            "-nqegcaar(aq*),-nqegcaar(ar)-",
            0
        ]
    },
    "\u2013nqigte[V\u2192V]": {
        "exp": "\u2013nqigte[V\u2192V]",
        "exp_display": "\u2013nqigte",
        "type": "VV",
        "description": "again",
        "postverb": "again",
        "match_case": true,
        "keylookup": [
            "-nqigte-",
            0
        ]
    },
    "\u2013nricen\u0304ar[V\u2192V]": {
        "exp": "\u2013nricen\u0304ar[V\u2192V]",
        "exp_display": "\u2013nricen\u0304ar",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "not (having changed his mind)",
        "gen_preverb": "not (having changed his mind)",
        "past_preverb": "not (having changed his mind)",
        "inf_preverb": "not (having changed his mind)",
        "ger_preverb": "not (having changed his mind)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-nricen\u0304ar-",
            0
        ]
    },
    "\u2013nrilkurte[V\u2192V]": {
        "exp": "\u2013nrilkurte[V\u2192V]",
        "exp_display": "\u2013nrilkurte",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "keeping ^himself^ from",
        "gen_preverb": "keeping ^himself^ from",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "keep ^himself^ from",
        "inf_preverb_after": "g",
        "ger_preverb": "keeping ^himself^ from",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "-nrilkurte-",
            0
        ]
    },
    "\u2013nrir[V\u2192V]": {
        "exp": "\u2013nrir[V\u2192V]",
        "exp_display": "\u2013nrir",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "no longer",
        "gen_preverb": "no longer",
        "past_preverb": "no longer",
        "inf_preverb": "no longer",
        "ger_preverb": "no longer",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-nrir-",
            0
        ]
    },
    "\u2013nritar(ar)[V\u2192V]": {
        "exp": "\u2013nritar(ar)[V\u2192V]",
        "exp_display": "\u2013nritar(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "almost",
        "gen_preverb": "almost",
        "past_preverb": "almost",
        "inf_preverb": "almost",
        "ger_preverb": "almost",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-nritar(ar)-",
            0
        ]
    },
    "\u2013nrite[V\u2192V]": {
        "exp": "\u2013nrite[V\u2192V]",
        "exp_display": "\u2013nrite\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "not",
        "gen_preverb": "not",
        "past_preverb": "not",
        "inf_preverb": "not",
        "ger_preverb": "not",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-nrite-",
            0
        ]
    },
    "\u2013nru[V\u2192V]": {
        "exp": "\u2013nru[V\u2192V]",
        "exp_display": "\u2013nru",
        "type": "VV",
        "description": "moreso",
        "postverb": "moreso",
        "match_case": true,
        "keylookup": [
            "-nru-",
            0
        ]
    },
    "@+paalug|~vaalug[V\u2192V]": {
        "exp": "@+paalug|~vaalug[V\u2192V]",
        "exp_display": "@\u2075+p|~vaalug",
        "type": "VV",
        "description": "for the first time",
        "postverb": "for the first time",
        "match_case": true,
        "keylookup": [
            "@+paalug-|~vaalug-,@+pailug-|~vailug-",
            0
        ]
    },
    "@+pailug|~vailug[V\u2192V]": {
        "exp": "@+pailug|~vailug[V\u2192V]",
        "exp_display": "@\u2075+p|~vailug",
        "type": "VV",
        "description": "for the first time",
        "postverb": "for the first time",
        "match_case": true,
        "keylookup": [
            "@+paalug-|~vaalug-,@+pailug-|~vailug-",
            1
        ]
    },
    "\u2013pacug[V\u2192V]": {
        "exp": "\u2013pacug[V\u2192V]",
        "exp_display": "\u2013pacug",
        "type": "VV",
        "description": "poorly, dearly",
        "postverb": "poorly, dearly",
        "match_case": true,
        "keylookup": [
            "-pacug-",
            0
        ]
    },
    "@+pag|~vag\u00b9[V\u2192V]": {
        "exp": "@+pag|~vag\u00b9[V\u2192V]",
        "exp_display": "@\u2075+p|~vag",
        "type": "VV",
        "description": "so well",
        "postverb": "so well",
        "match_case": true,
        "keylookup": [
            "@+pag-|~vag\u00b9-",
            0
        ]
    },
    "@+pakar|~vakar[V\u2192V]": {
        "exp": "@+pakar|~vakar[V\u2192V]",
        "exp_display": "@\u2075+p|~vakar",
        "type": "VV",
        "description": "so much",
        "postverb": "so much",
        "match_case": true,
        "keylookup": [
            "@+pakar-|~vakar-,-qpakar-",
            0
        ]
    },
    "\u2013qpakar[V\u2192V]": {
        "exp": "\u2013qpakar[V\u2192V]",
        "exp_display": "\u2013qpakar",
        "type": "VV",
        "description": "so much",
        "postverb": "so much",
        "match_case": true,
        "keylookup": [
            "@+pakar-|~vakar-,-qpakar-",
            1
        ]
    },
    "@+pallag|~vallag[V\u2192V]": {
        "exp": "@+pallag|~vallag[V\u2192V]",
        "exp_display": "@\u2075+p|~vallag",
        "type": "VV",
        "description": "intensely",
        "postverb": "intensely",
        "match_case": true,
        "keylookup": [
            "@+pallag-|~vallag-",
            0
        ]
    },
    "@+pallug|~vallug[V\u2192V]": {
        "exp": "@+pallug|~vallug[V\u2192V]",
        "exp_display": "@\u2075+p|~vallug",
        "type": "VV",
        "description": "the most",
        "postverb": "the most",
        "match_case": true,
        "keylookup": [
            "@+pallug-|~vallug-,@+pallur-|~vallur-",
            0
        ]
    },
    "@+pallur|~vallur[V\u2192V]": {
        "exp": "@+pallur|~vallur[V\u2192V]",
        "exp_display": "@\u2075+p|~vallur",
        "type": "VV",
        "description": "the most",
        "postverb": "the most",
        "match_case": true,
        "keylookup": [
            "@+pallug-|~vallug-,@+pallur-|~vallur-",
            1
        ]
    },
    "+peke|.vke[V\u2192V]": {
        "exp": "+peke|.vke[V\u2192V]",
        "exp_display": "+p|.vke\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "do not",
        "gen_preverb": "do not",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "not",
        "inf_preverb_after": "i",
        "ger_preverb": "not",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "+peke-|+vke-,+pege-|+vke-",
            0
        ]
    },
    "+pege|.vke[V\u2192V]": {
        "exp": "+pege|.vke[V\u2192V]",
        "exp_display": "+p|.vge\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "not",
        "gen_preverb": "not",
        "past_preverb": "not",
        "inf_preverb": "not",
        "ger_preverb": "not",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+peke-|+vke-,+pege-|+vke-",
            1
        ]
    },
    "+pigainar[V\u2192V]": {
        "exp": "+pigainar[V\u2192V]",
        "exp_display": "+pigainar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "actually (surprisingly)",
        "gen_preverb": "actually (surprisingly)",
        "past_preverb": "actually (surprisingly)",
        "inf_preverb": "actually (surprisingly)",
        "ger_preverb": "actually (surprisingly)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+pigainar-,-pigainar-",
            0
        ]
    },
    "\u2013pigainar[V\u2192V]": {
        "exp": "\u2013pigainar[V\u2192V]",
        "exp_display": "\u2013pigainar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "actually (surprisingly)",
        "gen_preverb": "actually (surprisingly)",
        "past_preverb": "actually (surprisingly)",
        "inf_preverb": "actually (surprisingly)",
        "ger_preverb": "actually (surprisingly)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+pigainar-,-pigainar-",
            1
        ]
    },
    "\u2013pig[V\u2192V]": {
        "exp": "\u2013pig[V\u2192V]",
        "exp_display": "\u2013pig",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "really",
        "gen_preverb": "really",
        "past_preverb": "really",
        "inf_preverb": "really",
        "ger_preverb": "really",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            3
        ]
    },
    "\u2013piar[V\u2192V]": {
        "exp": "\u2013piar[V\u2192V]",
        "exp_display": "\u2013piar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "really",
        "gen_preverb": "really",
        "past_preverb": "really",
        "inf_preverb": "really",
        "ger_preverb": "really",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            4
        ]
    },
    "\u2013pigar[V\u2192V]": {
        "exp": "\u2013pigar[V\u2192V]",
        "exp_display": "\u2013pigar",
        "type": "VV",
        "description": "very much so",
        "postverb": "very much so",
        "match_case": true,
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            5
        ]
    },
    "\u2013qaci[V\u2192V]": {
        "exp": "\u2013qaci[V\u2192V]",
        "exp_display": "\u2013q\u0332aci",
        "type": "VV",
        "description": "in a minor way",
        "postverb": "in a minor way",
        "match_case": true,
        "keylookup": [
            "-qaci-",
            0
        ]
    },
    "\u2013qainar[V\u2192V]": {
        "exp": "\u2013qainar[V\u2192V]",
        "exp_display": "\u2013q\u0332ainar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "merely",
        "gen_preverb": "merely",
        "past_preverb": "merely",
        "inf_preverb": "merely",
        "ger_preverb": "merely",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-qainaq,-qainar-",
            1
        ]
    },
    "\u2013qainaurte[V\u2192V]": {
        "exp": "\u2013qainaurte[V\u2192V]",
        "exp_display": "\u2013q\u0332ainaurte",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "ready to",
        "gen_preverb": "ready to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be ready to",
        "inf_preverb_after": "i",
        "ger_preverb": "being ready to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-qainaurte-",
            0
        ]
    },
    "\u2013qapiar(ar)[V\u2192V]": {
        "exp": "\u2013qapiar(ar)[V\u2192V]",
        "exp_display": "\u2013q\u0332apiar(ar)",
        "type": "VV",
        "description": "very much so",
        "postverb": "very much so",
        "match_case": true,
        "keylookup": [
            "-qapiar(ar)-",
            0
        ]
    },
    "\u2013qapigte[V\u2192V]": {
        "exp": "\u2013qapigte[V\u2192V]",
        "exp_display": "\u2013q\u0332apigte",
        "type": "VV",
        "description": "very much so",
        "postverb": "very much so",
        "match_case": true,
        "keylookup": [
            "-qapigte-",
            0
        ]
    },
    "\u2013qaqe\u00b9[V\u2192V]": {
        "exp": "\u2013qaqe\u00b9[V\u2192V]",
        "exp_display": "\u2013q\u0332araqe",
        "type": "VV",
        "description": "intermittently",
        "postverb": "intermittently",
        "match_case": true,
        "keylookup": [
            "-qaqe\u00b9-",
            0
        ]
    },
    "@qaqe\u00b2[V\u2192V]": {
        "exp": "@qaqe\u00b2[V\u2192V]",
        "exp_display": "@\u2075qaqe",
        "type": "VV",
        "description": "one after another",
        "postverb": "one after another",
        "match_case": true,
        "keylookup": [
            "@qaqe\u00b2-",
            0
        ]
    },
    "\u2013qaqu[V\u2192V]": {
        "exp": "\u2013qaqu[V\u2192V]",
        "exp_display": "\u2013q\u0332aqu",
        "type": "VV",
        "description": "now and then",
        "postverb": "now and then",
        "match_case": true,
        "keylookup": [
            "-qaqur(ar)-,-qaqu-",
            0
        ]
    },
    "\u2013qaqur(ar)[V\u2192V]": {
        "exp": "\u2013qaqur(ar)[V\u2192V]",
        "exp_display": "\u2013q\u0332aqur(ar)",
        "type": "VV",
        "description": "now and then",
        "postverb": "now and then",
        "match_case": true,
        "keylookup": [
            "-qaqur(ar)-,-qaqu-",
            1
        ]
    },
    "\u2013qar[V\u2192V]": {
        "exp": "\u2013qar[V\u2192V]",
        "exp_display": "\u2013q\u0332ar",
        "type": "VV",
        "description": "please",
        "postverb": "please",
        "match_case": true,
        "keylookup": [
            "-qar-",
            0
        ]
    },
    "\u2013qataar(ar)[V\u2192V]": {
        "exp": "\u2013qataar(ar)[V\u2192V]",
        "exp_display": "\u2013q\u0332ataar(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "slowly starting to",
        "gen_preverb": "slowly starting to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "slowly start to",
        "inf_preverb_after": "i",
        "ger_preverb": "slowly starting to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-qataar(ar)-",
            0
        ]
    },
    "\u2013qatar[V\u2192V]": {
        "exp": "\u2013qatar[V\u2192V]",
        "exp_display": "\u2013q\u0332atar",
        "type": "VV",
        "tense": "future",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "about to",
        "gen_preverb": "about to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be about to",
        "inf_preverb_after": "i",
        "ger_preverb": "being about to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-qatar-",
            0
        ]
    },
    "\u2013qcaar(ar)[V\u2192V]": {
        "exp": "\u2013qcaar(ar)[V\u2192V]",
        "exp_display": "\u2013q\u0332caar(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "trying (despite difficulties) to",
        "gen_preverb": "trying (despite difficulties) to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "try (despite difficulties) to",
        "inf_preverb_after": "i",
        "ger_preverb": "trying (despite difficulties) to ",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-qcaar(ar)-",
            0
        ]
    },
    "\u2013qerte[V\u2192V]": {
        "exp": "\u2013qerte[V\u2192V]",
        "exp_display": "\u2013qerte",
        "type": "VV",
        "description": "suddenly, hurriedly",
        "postverb": "suddenly, hurriedly",
        "match_case": true,
        "keylookup": [
            "-qerte-",
            0
        ]
    },
    "\u2013qetaar[V\u2192V]": {
        "exp": "\u2013qetaar[V\u2192V]",
        "exp_display": "\u2013q\u0332etaar",
        "type": "VV",
        "description": "repeatedly at intervals",
        "postverb": "repeatedly at intervals",
        "match_case": true,
        "keylookup": [
            "-qetaaq,-qetaar-",
            0
        ]
    },
    "@\u2013qtaar[V\u2192V]": {
        "exp": "@\u2013qtaar[V\u2192V]",
        "exp_display": "@\u2013qtaar",
        "type": "VV",
        "description": "repeatedly at intervals",
        "postverb": "repeatedly at intervals",
        "match_case": true,
        "keylookup": [
            "@-qtaar-",
            0
        ]
    },
    "\u2013qtar[V\u2192V]": {
        "exp": "\u2013qtar[V\u2192V]",
        "exp_display": "\u2013q\u0332tar",
        "type": "VV",
        "description": "weakly, helplessly, dearly",
        "postverb": "weakly, helplessly, dearly",
        "match_case": true,
        "keylookup": [
            "-qtaq*,-qtar-",
            1
        ]
    },
    "\u2013qtarar(ar)[V\u2192V]": {
        "exp": "\u2013qtarar(ar)[V\u2192V]",
        "exp_display": "\u2013q\u0332tarar(ar)",
        "type": "VV",
        "description": "slowly and with difficulty because of disability",
        "postverb": "slowly and with difficulty because of disability",
        "match_case": true,
        "keylookup": [
            "-qtarar(ar)-",
            0
        ]
    },
    "\u2013qu\u00b9[V\u2192V]": {
        "exp": "\u2013qu\u00b9[V\u2192V]",
        "exp_display": "\u2013q\u0332u",
        "type": "VV",
        "description": "one after another",
        "postverb": "one after another",
        "match_case": true,
        "keylookup": [
            "-qu\u00b9-",
            0
        ]
    },
    "@\u2013qur[V\u2192V]": {
        "exp": "@\u2013qur[V\u2192V]",
        "exp_display": "@\u2075\u2013qur",
        "type": "VV",
        "description": "using repeated action to accomplish the act",
        "postverb": "using repeated action to accomplish the act",
        "match_case": true,
        "keylookup": [
            "@-qur-",
            0
        ]
    },
    "\u2013rpaga[V\u2192V]": {
        "exp": "\u2013rpaga[V\u2192V]",
        "exp_display": "\u2013r\u0332paga",
        "type": "VV",
        "description": "hard at intervals",
        "postverb": "hard at intervals",
        "match_case": true,
        "keylookup": [
            "-rpaga-",
            0
        ]
    },
    "\u2013rpag[V\u2192V]": {
        "exp": "\u2013rpag[V\u2192V]",
        "exp_display": "\u2013r\u0332pag",
        "type": "VV",
        "description": "hard",
        "postverb": "hard",
        "match_case": true,
        "keylookup": [
            "-rpak,-rpag-",
            1
        ]
    },
    "\u2013rpakar[V\u2192V]": {
        "exp": "\u2013rpakar[V\u2192V]",
        "exp_display": "\u2013r\u0332pakar",
        "type": "VV",
        "description": "so much, for so long",
        "postverb": "so much, for so long",
        "match_case": true,
        "keylookup": [
            "-rpakar-",
            0
        ]
    },
    "@\u2013rqe\u00b9[V\u2192V]": {
        "exp": "@\u2013rqe\u00b9[V\u2192V]",
        "exp_display": "@\u2075\u2013rqe",
        "type": "VV",
        "description": "one after another",
        "postverb": "one after another",
        "match_case": true,
        "keylookup": [
            "@-rqe\u00b9-",
            0
        ]
    },
    "\u2013rrar[V\u2192V]": {
        "exp": "\u2013rrar[V\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332ar",
        "type": "VV",
        "description": "just barely",
        "postverb": "just barely",
        "match_case": true,
        "keylookup": [
            "-rraq*,-rrar-",
            1
        ]
    },
    "\u2013rraar[V\u2192V]": {
        "exp": "\u2013rraar[V\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332aar",
        "type": "VV",
        "description": "first",
        "postverb": "first",
        "match_case": true,
        "keylookup": [
            "-rraar-",
            0
        ]
    },
    "\u2013rrlainar[V\u2192V]": {
        "exp": "\u2013rrlainar[V\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332lainar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "constantly",
        "gen_preverb": "constantly",
        "past_preverb": "constantly",
        "inf_preverb": "constantly",
        "ger_preverb": "constantly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-rrlainaq*,-rrlainar-",
            1
        ]
    },
    "\u2013rrluar(ar)[V\u2192V]": {
        "exp": "\u2013rrluar(ar)[V\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332luar(ar)",
        "type": "VV",
        "description": "a little bit",
        "postverb": "a little bit",
        "match_case": true,
        "keylookup": [
            "-rrluar(ar)-",
            0
        ]
    },
    "\u2013rrlug[V\u2192V]": {
        "exp": "\u2013rrlug[V\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332lug",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "somewhat",
        "gen_preverb": "somewhat",
        "past_preverb": "somewhat",
        "inf_preverb": "somewhat",
        "ger_preverb": "somewhat",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-rrluk,-rrlug-,-rrlugte-",
            3
        ]
    },
    "\u2013rrlugte[V\u2192V]": {
        "exp": "\u2013rrlugte[V\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332lugte",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "somewhat",
        "gen_preverb": "somewhat",
        "past_preverb": "somewhat",
        "inf_preverb": "somewhat",
        "ger_preverb": "somewhat",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-rrluk,-rrlug-,-rrlugte-",
            4
        ]
    },
    "\u2013q(ur)lur[V\u2192V]": {
        "exp": "\u2013q(ur)lur[V\u2192V]",
        "exp_display": "\u2013r\u0332(ur)lur",
        "type": "VV",
        "description": "poorly, dearly",
        "postverb": "poorly, dearly",
        "match_case": true,
        "keylookup": [
            "-r(ur)luq*,-q(ur)lur-",
            1
        ]
    },
    "\u2013rvaar[V\u2192V]": {
        "exp": "\u2013rvaar[V\u2192V]",
        "exp_display": "\u2013r\u0332vaar",
        "type": "VV",
        "description": "very much so",
        "postverb": "very much so",
        "match_case": true,
        "keylookup": [
            "-rvaar-",
            0
        ]
    },
    "\u2013rvag[V\u2192V]": {
        "exp": "\u2013rvag[V\u2192V]",
        "exp_display": "\u2013r\u0332vag",
        "type": "VV",
        "description": "very much so",
        "postverb": "very much so",
        "match_case": true,
        "keylookup": [
            "-rvag-",
            0
        ]
    },
    "\u2013sciigate[V\u2192V]": {
        "exp": "\u2013sciigate[V\u2192V]",
        "exp_display": "\u2013sciigate\u00b0",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "unable to",
        "gen_preverb": "unable to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be unable to",
        "inf_preverb_after": "i",
        "ger_preverb": "being unable to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-sciigate-",
            0
        ]
    },
    "\u2013ssaag\u00b9[V\u2192V]": {
        "exp": "\u2013ssaag\u00b9[V\u2192V]",
        "exp_display": "\u2013ssaag",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "trying to",
        "gen_preverb": "trying to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "try to",
        "inf_preverb_after": "i",
        "ger_preverb": "trying to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-ssaag\u00b9-",
            0
        ]
    },
    "\u2013ssaag\u00b3[V\u2192V]": {
        "exp": "\u2013ssaag\u00b3[V\u2192V]",
        "exp_display": "\u2013ssaag",
        "type": "VV",
        "description": "too much",
        "postverb": "too much",
        "match_case": true,
        "keylookup": [
            "-ssaag\u00b3-",
            0
        ]
    },
    "\u2013ssiyaag[V\u2192V]": {
        "exp": "\u2013ssiyaag[V\u2192V]",
        "exp_display": "\u2013ssiyaag",
        "type": "VV",
        "description": "too much",
        "postverb": "too much",
        "match_case": true,
        "keylookup": [
            "-ssiyaag-",
            0
        ]
    },
    "@+ta\u00b2[V\u2192V]": {
        "exp": "@+ta\u00b2[V\u2192V]",
        "exp_display": "@\u00b2+ta",
        "type": "VV",
        "description": "to a certain degree",
        "postverb": "to a certain degree",
        "match_case": true,
        "keylookup": [
            "@+ta\u00b2-",
            0
        ]
    },
    "+taagute[V\u2192V]": {
        "exp": "+taagute[V\u2192V]",
        "exp_display": "+taagute",
        "type": "VV",
        "description": "back and forth",
        "postverb": "back and forth",
        "match_case": true,
        "keylookup": [
            "+taagute-",
            0
        ]
    },
    "@+taar\u00b9[V\u2192V]": {
        "exp": "@+taar\u00b9[V\u2192V]",
        "exp_display": "@\u2074+taar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "acting so as to try to make others feel that ^he^ is",
        "gen_preverb": "acting so as to try to make others feel that ^he^ is",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "act so as to try to make others feel that ^he^ is",
        "inf_preverb_after": "g",
        "ger_preverb": "acting so as to try to make others feel that ^he^ is",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@+taar\u00b9-",
            0
        ]
    },
    "+tar\u00b9[V\u2192V]": {
        "exp": "+tar\u00b9[V\u2192V]",
        "exp_display": "+tar",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "tends to often",
        "gen_preverb": "tends to often",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "tended to often",
        "past_preverb_after": "i",
        "inf_preverb": "tend to often",
        "inf_preverb_after": "i",
        "ger_preverb": "tending to often",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+tar\u00b9-",
            1
        ]
    },
    "+ter[V\u2192V]": {
        "exp": "+ter[V\u2192V]",
        "exp_display": "+ter",
        "type": "VV",
        "description": "suddenly and willfully",
        "postverb": "suddenly and willfully",
        "match_case": true,
        "keylookup": [
            "+ter-",
            0
        ]
    },
    "\u2013tngurte[V\u2192V]": {
        "exp": "\u2013tngurte[V\u2192V]",
        "exp_display": "\u2013tngurte",
        "type": "VV",
        "description": "unexpectedly",
        "postverb": "unexpectedly",
        "match_case": true,
        "keylookup": [
            "-tngurte-,-tmurte\u00b2-",
            0
        ]
    },
    "\u2013tmurte\u00b2[V\u2192V]": {
        "exp": "\u2013tmurte\u00b2[V\u2192V]",
        "exp_display": "\u2013tmurte",
        "type": "VV",
        "description": "unexpectedly",
        "postverb": "unexpectedly",
        "match_case": true,
        "keylookup": [
            "-tngurte-,-tmurte\u00b2-",
            1
        ]
    },
    "\u2013tu[V\u2192V]": {
        "exp": "\u2013tu[V\u2192V]",
        "exp_display": "\u2013tu",
        "type": "VV",
        "description": "customarily",
        "postverb": "customarily",
        "match_case": true,
        "keylookup": [
            "+tu-,-tu-",
            1
        ]
    },
    "+tuinar[V\u2192V]": {
        "exp": "+tuinar[V\u2192V]",
        "exp_display": "+tuinar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "always",
        "gen_preverb": "always",
        "past_preverb": "always",
        "inf_preverb": "always",
        "ger_preverb": "always",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "+tuinar-",
            0
        ]
    },
    "\u2013turnir[V\u2192V]": {
        "exp": "\u2013turnir[V\u2192V]",
        "exp_display": "\u2013turnir",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "proficiently able to",
        "gen_preverb": "proficiently able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be proficiently able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being proficiently able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-turnir-",
            0
        ]
    },
    "@~+(ng)uar[V\u2192V]": {
        "exp": "@~+(ng)uar[V\u2192V]",
        "exp_display": "@\u00b2~+(ng)uar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "pretending to",
        "gen_preverb": "pretending to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "pretend to",
        "inf_preverb_after": "i",
        "ger_preverb": "pretending to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "+(ng)uaq,@~+(ng)uar-",
            1
        ]
    },
    "@+`(g|t)ur(ar)[V\u2192V]": {
        "exp": "@+`(g|t)ur(ar)[V\u2192V]",
        "exp_display": "@\u02c1+`(g|t)ur(ar)",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "continuing to",
        "gen_preverb": "continuing to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "continue to",
        "inf_preverb_after": "i",
        "ger_preverb": "continuing to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@+'(g|t)ur(ar)-",
            0
        ]
    },
    "@+`(g|t)urainar[V\u2192V]": {
        "exp": "@+`(g|t)urainar[V\u2192V]",
        "exp_display": "@\u02c1+`(g|t)urainar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "finally (after desiring to but not being able to)",
        "gen_preverb": "finally (after desiring to but not being able to)",
        "past_preverb": "finally (after desiring to but not being able to)",
        "inf_preverb": "finally (after desiring to but not being able to)",
        "ger_preverb": "finally (after desiring to but not being able to)",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@+'(g|t)urainar-",
            0
        ]
    },
    "@+`(g|t)uralar[V\u2192V]": {
        "exp": "@+`(g|t)uralar[V\u2192V]",
        "exp_display": "@\u02c1+`(g|t)uralar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "always",
        "gen_preverb": "always",
        "past_preverb": "always",
        "inf_preverb": "always",
        "ger_preverb": "always",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@+'(g|t)uralar-,@+'(g|t)ur(ar)lar-,@+'(g|t)uratu-",
            0
        ]
    },
    "@+`(g|t)ur(ar)lar[V\u2192V]": {
        "exp": "@+`(g|t)ur(ar)lar[V\u2192V]",
        "exp_display": "@\u02c1+`(g|t)ur(ar)lar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "always",
        "gen_preverb": "always",
        "past_preverb": "always",
        "inf_preverb": "always",
        "ger_preverb": "always",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@+'(g|t)uralar-,@+'(g|t)ur(ar)lar-,@+'(g|t)uratu-",
            1
        ]
    },
    "@+`(g|t)uratu[V\u2192V]": {
        "exp": "@+`(g|t)uratu[V\u2192V]",
        "exp_display": "@\u02c1+`(g|t)uratu",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "always",
        "gen_preverb": "always",
        "past_preverb": "always",
        "inf_preverb": "always",
        "ger_preverb": "always",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@+'(g|t)uralar-,@+'(g|t)ur(ar)lar-,@+'(g|t)uratu-",
            2
        ]
    },
    "\u2013vguar(ar)[V\u2192V]": {
        "exp": "\u2013vguar(ar)[V\u2192V]",
        "exp_display": "\u2013vguar(ar)",
        "type": "VV",
        "description": "a little bit",
        "postverb": "a little bit",
        "match_case": true,
        "keylookup": [
            "-vguar(ar)-",
            0
        ]
    },
    "\u2013vialug[V\u2192V]": {
        "exp": "\u2013vialug[V\u2192V]",
        "exp_display": "\u2013vialug",
        "type": "VV",
        "description": "clumsily",
        "postverb": "clumsily",
        "match_case": true,
        "keylookup": [
            "-vialuk,-vialug-",
            1
        ]
    },
    "\u2013viite[V\u2192V]": {
        "exp": "\u2013viite[V\u2192V]",
        "exp_display": "\u2013viite",
        "type": "VV",
        "subj": "it",
        "is": false,
        "has": false,
        "description": "leaves no room or place to",
        "gen_preverb": "leaves no room or place to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "left no room or place to",
        "past_preverb_after": "i",
        "inf_preverb": "leave no room or place to",
        "inf_preverb_after": "i",
        "ger_preverb": "leaving no room or place to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "-viite-",
            0
        ]
    },
    "\u2013vlaag[V\u2192V]": {
        "exp": "\u2013vlaag[V\u2192V]",
        "exp_display": "\u2013vlaag",
        "type": "VV",
        "description": "insufficiently",
        "postverb": "insufficiently",
        "match_case": true,
        "keylookup": [
            "-vlaag-",
            0
        ]
    },
    "\u2013vlugte[V\u2192V]": {
        "exp": "\u2013vlugte[V\u2192V]",
        "exp_display": "\u2013vlugte",
        "type": "VV",
        "description": "sloppily",
        "postverb": "sloppily",
        "match_case": true,
        "keylookup": [
            "-vlugte-",
            0
        ]
    },
    "\u2013vsiar[V\u2192V]": {
        "exp": "\u2013vsiar[V\u2192V]",
        "exp_display": "\u2013vsiar",
        "type": "VV",
        "description": "even more to completion",
        "postverb": "even more to completion",
        "match_case": true,
        "keylookup": [
            "-vsiar-,-vyiar-",
            0
        ]
    },
    "\u2013vyiar[V\u2192V]": {
        "exp": "\u2013vyiar[V\u2192V]",
        "exp_display": "\u2013vyiar",
        "type": "VV",
        "description": "even more to completion",
        "postverb": "even more to completion",
        "match_case": true,
        "keylookup": [
            "-vsiar-,-vyiar-",
            1
        ]
    },
    "\u2013vyirte[V\u2192V]": {
        "exp": "\u2013vyirte[V\u2192V]",
        "exp_display": "\u2013vyirte",
        "type": "VV",
        "description": "around here and there",
        "postverb": "around here and there",
        "match_case": true,
        "keylookup": [
            "-vyirte-",
            0
        ]
    },
    "@~+yaaqe[V\u2192V]": {
        "exp": "@~+yaaqe[V\u2192V]",
        "exp_display": "@\u02b8~+yaaqe",
        "type": "VV",
        "description": "in vain (fruitlessly)",
        "postverb": "in vain (fruitlessly)",
        "match_case": true,
        "keylookup": [
            "@~+yaaqe-",
            0
        ]
    },
    "\u2013ya(g)ar[V\u2192V]": {
        "exp": "\u2013ya(g)ar[V\u2192V]",
        "exp_display": "\u2013ya\u0121ar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "very cutely or dearly",
        "gen_preverb": "very cutely or dearly",
        "past_preverb": "very cutely or dearly",
        "inf_preverb": "very cutely or dearly",
        "ger_preverb": "very cutely or dearly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",
            2
        ]
    },
    "\u2013yagar[V\u2192V]": {
        "exp": "\u2013yagar[V\u2192V]",
        "exp_display": "\u2013yagar",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "very cutely or dearly",
        "gen_preverb": "very cutely or dearly",
        "past_preverb": "very cutely or dearly",
        "inf_preverb": "very cutely or dearly",
        "ger_preverb": "very cutely or dearly",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",
            3
        ]
    },
    "@~+yalqar[V\u2192V]": {
        "exp": "@~+yalqar[V\u2192V]",
        "exp_display": "@\u02b8~+yalqar",
        "type": "VV",
        "description": "without recompense",
        "postverb": "without recompense",
        "match_case": true,
        "keylookup": [
            "@~+yalqar-",
            0
        ]
    },
    "@~+yaqlir[V\u2192V]": {
        "exp": "@~+yaqlir[V\u2192V]",
        "exp_display": "@\u02b8~+yaqlir",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "finally",
        "gen_preverb": "finally",
        "past_preverb": "finally",
        "inf_preverb": "finally",
        "ger_preverb": "finally",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@~+yaqlir-",
            0
        ]
    },
    "@~+yarar[V\u2192V]": {
        "exp": "@~+yarar[V\u2192V]",
        "exp_display": "@\u02b8~+yarar",
        "type": "VV",
        "description": "early",
        "postverb": "early",
        "match_case": true,
        "keylookup": [
            "@~+yarar-",
            0
        ]
    },
    "@~+yarar(ar)[V\u2192V]": {
        "exp": "@~+yarar(ar)[V\u2192V]",
        "exp_display": "@\u02b8~+yarar(ar)",
        "type": "VV",
        "description": "very early",
        "postverb": "very early",
        "match_case": true,
        "keylookup": [
            "@~+yarar(ar)-",
            0
        ]
    },
    "@~+yarpiar[V\u2192V]": {
        "exp": "@~+yarpiar[V\u2192V]",
        "exp_display": "@\u02b8~+yarpiar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "almost",
        "gen_preverb": "almost",
        "past_preverb": "almost",
        "inf_preverb": "almost",
        "ger_preverb": "almost",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@~+yarpiar-,~+yarpigar-",
            0
        ]
    },
    "~+yarpigar[V\u2192V]": {
        "exp": "~+yarpigar[V\u2192V]",
        "exp_display": "~+yarpigar",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "almost",
        "gen_preverb": "almost",
        "past_preverb": "almost",
        "inf_preverb": "almost",
        "ger_preverb": "almost",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@~+yarpiar-,~+yarpigar-",
            1
        ]
    },
    "@~+yartur[V\u2192V]": {
        "exp": "@~+yartur[V\u2192V]",
        "exp_display": "@\u02b8~+yartur",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "going to",
        "gen_preverb": "going to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "go",
        "inf_preverb_after": "g",
        "ger_preverb": "going",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+yartur-",
            0
        ]
    },
    "@~+yaurciiqe[V\u2192V]": {
        "exp": "@~+yaurciiqe[V\u2192V]",
        "exp_display": "@\u02b8~+yaurciiqe",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "starting and continuing to",
        "gen_preverb": "starting and continuing to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "start and continue to",
        "inf_preverb_after": "i",
        "ger_preverb": "starting and continuing to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yaurciiqe-",
            0
        ]
    },
    "@~+yaurte[V\u2192V]": {
        "exp": "@~+yaurte[V\u2192V]",
        "exp_display": "@\u02b8~+yaurte",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "now able to",
        "gen_preverb": "now able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be now able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being now able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yaurte-",
            0
        ]
    },
    "@~\u2013yu[V\u2192V]": {
        "exp": "@~\u2013yu[V\u2192V]",
        "exp_display": "@\u02b8~\u2013yu",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "well able to",
        "gen_preverb": "well able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be well able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being well able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~-yu-",
            0
        ]
    },
    "@~+yuar[V\u2192V]": {
        "exp": "@~+yuar[V\u2192V]",
        "exp_display": "@\u02b8~+yuar",
        "type": "VV",
        "subj": "",
        "is": false,
        "has": false,
        "description": "",
        "gen_preverb": "",
        "gen_preverb_after": "",
        "was": false,
        "past_preverb": "",
        "past_preverb_after": "",
        "inf_preverb": "",
        "inf_preverb_after": "i",
        "ger_preverb": "",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+yuar-",
            0
        ]
    },
    "@~+yug[V\u2192V]": {
        "exp": "@~+yug[V\u2192V]",
        "exp_display": "@\u02b8~+yug",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "wants to",
        "gen_preverb": "wants to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "wanted to",
        "past_preverb_after": "i",
        "inf_preverb": "want to",
        "inf_preverb_after": "i",
        "ger_preverb": "wanting to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yug-,+(r)yug-",
            2
        ]
    },
    "@~+yugar[V\u2192V]": {
        "exp": "@~+yugar[V\u2192V]",
        "exp_display": "@\u02b8~+yugar",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "enjoys ^his^",
        "gen_preverb": "enjoys ^his^",
        "gen_preverb_after": "g",
        "was": false,
        "past_preverb": "enjoyed ^his^",
        "past_preverb_after": "g",
        "inf_preverb": "enjoy ^his^",
        "inf_preverb_after": "g",
        "ger_preverb": "enjoying ^his^",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+yugar-",
            0
        ]
    },
    "@~+yugcali[V\u2192V]": {
        "exp": "@~+yugcali[V\u2192V]",
        "exp_display": "@\u02b8~+yugcali",
        "type": "VV",
        "description": "heartily",
        "postverb": "heartily",
        "match_case": true,
        "keylookup": [
            "@~+yugcali-",
            0
        ]
    },
    "@~+yugnairute[V\u2192V]": {
        "exp": "@~+yugnairute[V\u2192V]",
        "exp_display": "@\u02b8~+yugnairute",
        "type": "VV",
        "neg": true,
        "subj": "it",
        "is": true,
        "has": false,
        "description": "definitely no longer going to",
        "gen_preverb": "definitely no longer going to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be definitely no longer going to",
        "inf_preverb_after": "i",
        "ger_preverb": "being definitely no longer going to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yugnairute-",
            0
        ]
    },
    "@~+yugnaite\u00b9[V\u2192V]": {
        "exp": "@~+yugnaite\u00b9[V\u2192V]",
        "exp_display": "@\u02b8~+yugnaite\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "it",
        "is": true,
        "has": false,
        "description": "definitely not going to ",
        "gen_preverb": "definitely not going to ",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be definitely not going to ",
        "inf_preverb_after": "i",
        "ger_preverb": "being definitely not going to ",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yugnaite\u00b9-",
            0
        ]
    },
    "@~+yugnarqe\u00b9[V\u2192V]": {
        "exp": "@~+yugnarqe\u00b9[V\u2192V]",
        "exp_display": "@\u02b8~+yugnarqe",
        "type": "VV",
        "description": "probably",
        "postverb": "probably",
        "match_case": true,
        "keylookup": [
            "@~+yugnarqe\u00b9-",
            0
        ]
    },
    "@~+yugnarqe\u00b2[V\u2192V]": {
        "exp": "@~+yugnarqe\u00b2[V\u2192V]",
        "exp_display": "@\u02b8~+yugnarqe",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "such as to make one want to",
        "gen_preverb": "such as to make one want to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be such as to make one want to",
        "inf_preverb_after": "i",
        "ger_preverb": "being such as to make one want to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yugnarqe\u00b2-",
            0
        ]
    },
    "@~+yugnga[V\u2192V]": {
        "exp": "@~+yugnga[V\u2192V]",
        "exp_display": "@\u02b8~+yugnga",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "able to",
        "gen_preverb": "able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yugnga-",
            0
        ]
    },
    "@~+yugyaaqe[V\u2192V]": {
        "exp": "@~+yugyaaqe[V\u2192V]",
        "exp_display": "@\u02b8~+yugyaaqe",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "wants (provided it is all right) to",
        "gen_preverb": "wants (provided it is all right) to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "wanted (provided it was all right) to",
        "past_preverb_after": "i",
        "inf_preverb": "want (provided it is all right) to",
        "inf_preverb_after": "i",
        "ger_preverb": "wanting (provided it is all right) to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yugyaaqe-",
            0
        ]
    },
    "@~\u2013yuirute[V\u2192V]": {
        "exp": "@~\u2013yuirute[V\u2192V]",
        "exp_display": "@\u02b8~\u2013yuirute",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "no longer",
        "gen_preverb": "no longer",
        "gen_preverb_after": "g",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "g",
        "inf_preverb": "be no longer",
        "inf_preverb_after": "g",
        "ger_preverb": "being no longer",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~-yuirute-",
            0
        ]
    },
    "@~\u2013yuite[V\u2192V]": {
        "exp": "@~\u2013yuite[V\u2192V]",
        "exp_display": "@\u02b8~\u2013yuite\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "never",
        "gen_preverb": "never",
        "past_preverb": "never",
        "inf_preverb": "never",
        "ger_preverb": "never",
        "match_case": true,
        "gen_preverb_after": "g",
        "keylookup": [
            "@~-yuite-",
            0
        ]
    },
    "@~+yukaar(ar)[V\u2192V]": {
        "exp": "@~+yukaar(ar)[V\u2192V]",
        "exp_display": "@\u02b8~+yukaar(ar)",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "ready to",
        "gen_preverb": "ready to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be ready to",
        "inf_preverb_after": "i",
        "ger_preverb": "being ready to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yukaar(ar)-",
            0
        ]
    },
    "@~\u2013yunaite[V\u2192V]": {
        "exp": "@~\u2013yunaite[V\u2192V]",
        "exp_display": "@\u02b8~\u2013yunaite\u00b0",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "impossible to be",
        "gen_preverb": "impossible to be",
        "gen_preverb_after": "pp",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "pp",
        "inf_preverb": "be impossible to be",
        "inf_preverb_after": "pp",
        "ger_preverb": "being impossible to be",
        "ger_preverb_after": "pp",
        "match_case": false,
        "keylookup": [
            "@~-yunaite-",
            0
        ]
    },
    "@~\u2013yunarqe[V\u2192V]": {
        "exp": "@~\u2013yunarqe[V\u2192V]",
        "exp_display": "@\u02b8~\u2013yunarqe",
        "type": "VV",
        "subj": "it",
        "is": true,
        "has": false,
        "description": "possible to",
        "gen_preverb": "possible to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be possible to",
        "inf_preverb_after": "i",
        "ger_preverb": "being possible to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~-yunarqe-",
            0
        ]
    },
    "@~+yunqegg[V\u2192V]": {
        "exp": "@~+yunqegg[V\u2192V]",
        "exp_display": "@\u02b8~+yunqegg",
        "type": "VV",
        "subj": "he",
        "is": false,
        "has": false,
        "description": "loves",
        "gen_preverb": "loves",
        "gen_preverb_after": "g",
        "was": false,
        "past_preverb": "loved",
        "past_preverb_after": "g",
        "inf_preverb": "love",
        "inf_preverb_after": "g",
        "ger_preverb": "loving",
        "ger_preverb_after": "g",
        "match_case": false,
        "keylookup": [
            "@~+yunqegg-",
            0
        ]
    },
    "@~+yunrite[V\u2192V]": {
        "exp": "@~+yunrite[V\u2192V]",
        "exp_display": "@\u02b8~+yunrite\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": true,
        "has": false,
        "description": "continuing not to",
        "gen_preverb": "continuing not to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "continue not to",
        "inf_preverb_after": "i",
        "ger_preverb": "continuing not to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yunrite-",
            0
        ]
    },
    "@~+yuuma[V\u2192V]": {
        "exp": "@~+yuuma[V\u2192V]",
        "exp_display": "@\u02b8~+yuuma",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "able to",
        "gen_preverb": "able to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "be able to",
        "inf_preverb_after": "i",
        "ger_preverb": "being able to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yuuma-",
            0
        ]
    },
    "@~+yuumiir(ar)te[V\u2192V]": {
        "exp": "@~+yuumiir(ar)te[V\u2192V]",
        "exp_display": "@\u02b8~+yuumiir(ar)te",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "no longer wants to",
        "gen_preverb": "no longer wants to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "no longer wanted to",
        "past_preverb_after": "i",
        "inf_preverb": "no longer want to",
        "inf_preverb_after": "i",
        "ger_preverb": "no longer wanting to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yuumiir(ar)te-",
            0
        ]
    },
    "@~+yuumiite[V\u2192V]": {
        "exp": "@~+yuumiite[V\u2192V]",
        "exp_display": "@\u02b8~+yuumiite\u00b0",
        "type": "VV",
        "neg": true,
        "subj": "he",
        "is": false,
        "has": false,
        "description": "not care to",
        "gen_preverb": "not care to",
        "gen_preverb_after": "i",
        "was": false,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "not care to",
        "inf_preverb_after": "i",
        "ger_preverb": "not caring to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yuumiite-",
            0
        ]
    },
    "@~+yuumir[V\u2192V]": {
        "exp": "@~+yuumir[V\u2192V]",
        "exp_display": "@\u02b8~+yuumir",
        "type": "VV",
        "subj": "he",
        "is": true,
        "has": false,
        "description": "yearning to",
        "gen_preverb": "yearning to",
        "gen_preverb_after": "i",
        "was": true,
        "past_preverb": "",
        "past_preverb_after": "i",
        "inf_preverb": "yearn to",
        "inf_preverb_after": "i",
        "ger_preverb": "yearning to",
        "ger_preverb_after": "i",
        "match_case": false,
        "keylookup": [
            "@~+yuumir-",
            0
        ]
    },
    "\u2013lria|@ngur*[V\u2192N]": {
        "exp": "\u2013lria|@ngur*[V\u2192N]",
        "exp_display": "\u2013lria|@\u2074+ngur*",
        "description": "the one who is V-ing",
        "singularDefinition": "who is",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "that are",
        "match_case": false,
        "keylookup": [
            "@nguq*",
            0
        ]
    },
    "+`(g)ar\u00b9[V\u2192N]": {
        "exp": "+`(g)ar\u00b9[V\u2192N]",
        "exp_display": "+`(g)ar",
        "description": "that which has been V-ed",
        "singularDefinition": "which has been",
        "type": "VN",
        "verbType": "past",
        "pluralDefinition": "that have been",
        "match_case": false,
        "keylookup": [
            "+'(g)aq\u00b9",
            0
        ]
    },
    "+`(g)arkar[V\u2192N]": {
        "exp": "+`(g)arkar[V\u2192N]",
        "exp_display": "+`(g)arkar",
        "description": "that which is to be V-ed; that which will V",
        "singularDefinition": "which is to be",
        "type": "VN",
        "verbType": "past",
        "pluralDefinition": "that have to be",
        "match_case": false,
        "keylookup": [
            "+'(g)arkaq",
            0
        ]
    },
    "+`(g)arkaqenrilke[V\u2192N]": {
        "exp": "+`(g)arkaqenrilke[V\u2192N]",
        "exp_display": "+`(g)arkaqenrilke",
        "description": "that which possessor must, should or would not V",
        "singularDefinition": "which possessor must or should not",
        "type": "VN",
        "verbType": "i",
        "pluralDefinition": "that possessor must or should not",
        "match_case": false,
        "keylookup": [
            "+'(g)arkaqenrilka\u1d49",
            0
        ]
    },
    "@~+cetaar[V\u2192N]": {
        "exp": "@~+cetaar[V\u2192N]",
        "exp_display": "@\u2075~+cetaar",
        "description": "something used to cause one to V",
        "singularDefinition": "used to cause one to",
        "type": "VN",
        "verbType": "i",
        "match_case": false,
        "keylookup": [
            "@~+cetaaq,@~+cetaar-",
            1
        ]
    },
    "@:(u)cir[V\u2192N]": {
        "exp": "@%:(u)cir[V\u2192N]",
        "exp_display": "@\u00b3%:(u)cir|@\u2075cir",
        "description": "condition of possessor with respect to V; incidence of V; occurrence of V",
        "singularDefinition": "condition of possessor with respect to",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "conditions of possessor with respect to",
        "match_case": false,
        "keylookup": [
            "@:(u)ciq",
            0
        ]
    },
    "@:(u)cirkar[V\u2192N]": {
        "exp": "@%:(u)cirkar[V\u2192N]",
        "exp_display": "@\u00b3%:(u)cirkar",
        "description": "future condition of possessor with respect to V",
        "singularDefinition": "future condition of possessor with respect to",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "future conditions of possessor with respect to",
        "match_case": false,
        "keylookup": [
            "@:(u)cirkaq",
            0
        ]
    },
    "@~+citaar[V\u2192N]": {
        "exp": "@~+citaar[V\u2192N]",
        "exp_display": "@\u2075~+citaar",
        "description": "something used to cause one to V",
        "singularDefinition": "used to cause one to",
        "type": "VN",
        "verbType": "i",
        "match_case": false,
        "keylookup": [
            "@~+citaaq,@~+citaar-",
            1
        ]
    },
    "\u2013curlag[V\u2192N]": {
        "exp": "\u2013curlag[V\u2192N]",
        "exp_display": "\u2013curlag",
        "description": "misfortune in V-ing",
        "singularDefinition": "misfortune in",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "misfortunes in",
        "match_case": false,
        "keylookup": [
            "-curlak,-curlag-",
            1
        ]
    },
    "+cuute|+ssuute[V\u2192N]": {
        "exp": "+cuute|+ssuute[V\u2192N]",
        "exp_display": "+c|.ssuute",
        "description": "device for V-ing, device associated with N",
        "singularDefinition": "device for",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for",
        "match_case": false,
        "keylookup": [
            "+cuun|+ssuun",
            0
        ]
    },
    "+(s)kar(ar*)\u00b2[V\u2192N]": {
        "exp": "+(s)kar(ar*)\u00b2[V\u2192N]",
        "exp_display": "+(s)kar(ar*)",
        "description": "one who Vs; the only one who Vs",
        "singularDefinition": "only one who",
        "type": "VN",
        "verbType": "present",
        "pluralDefinition": "only one who",
        "match_case": false,
        "keylookup": [
            "+(s)kar(aq*)\u00b2",
            0
        ]
    },
    "@~\u2013ke\u00b9[V\u2192N]": {
        "exp": "@~\u2013ke\u00b9[V\u2192N]",
        "exp_display": "@\u2074~\u2013k\u0332e",
        "description": "(@~-ke-1) the one or ones that the possessor is V-ing",
        "singularDefinition": "which the possessor is",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "that the possessor is",
        "match_case": false,
        "keylookup": [
            "@~-ka\u1d49,@~-ke\u00b9-",
            0
        ]
    },
    "@~\u2013kengar[V\u2192N]": {
        "exp": "@~\u2013kengar[V\u2192N]",
        "exp_display": "@\u2075~\u2013kengar",
        "description": "one that is being V-ed",
        "singularDefinition": "that is being",
        "type": "VN",
        "verbType": "past",
        "pluralDefinition": "that are being",
        "match_case": false,
        "keylookup": [
            "@~-kengaq",
            0
        ]
    },
    "+li\u00b9[V\u2192N]": {
        "exp": "+li\u00b9[V\u2192N]",
        "exp_display": "+li",
        "description": "one who is V; one who Vs; one having V; one similar to N",
        "singularDefinition": "who",
        "type": "VN",
        "verbType": "present",
        "pluralDefinition": "who",
        "match_case": false,
        "keylookup": [
            "+li\u00b9,+liq",
            2
        ]
    },
    "+lir[V\u2192N]": {
        "exp": "+lir[V\u2192N]",
        "exp_display": "+lir",
        "description": "one who is V; one who Vs; one having V; one similar to N",
        "singularDefinition": "who",
        "type": "VN",
        "verbType": "present",
        "pluralDefinition": "who",
        "match_case": false,
        "keylookup": [
            "+li\u00b9,+liq",
            3
        ]
    },
    "\u2013ller\u00b9[V\u2192N]": {
        "exp": "\u2013ller\u00b9[V\u2192N]",
        "exp_display": "\u2013ller",
        "description": "former N; one that V-ed or was V-ed; act or state of V-ing",
        "singularDefinition": "act or state of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "acts or states of",
        "match_case": false,
        "keylookup": [
            "-lleq\u00b9",
            1
        ]
    },
    "@ller\u00b2[V\u2192N]": {
        "exp": "@ller\u00b2[V\u2192N]",
        "exp_display": "@\u2075ller",
        "description": "one more V than possessor(s), the most V of the possessors",
        "singularDefinition": "more (compared to possessor)",
        "type": "VN",
        "pluralDefinition": "more (compared to possessor)",
        "match_case": false,
        "keylookup": [
            "@lleq\u00b2",
            0
        ]
    },
    "\u2013llerkar[V\u2192N]": {
        "exp": "\u2013llerkar[V\u2192N]",
        "exp_display": "\u2013llerkar",
        "description": "future act of V-ing; unrealized act of V-ing",
        "singularDefinition": "future act of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "future acts of",
        "match_case": false,
        "keylookup": [
            "-llerkaq",
            0
        ]
    },
    "\u2013llgute[V\u2192N]": {
        "exp": "\u2013llgute[V\u2192N]",
        "exp_display": "\u2013llgute",
        "description": "fellow V-er; V-ing partner",
        "singularDefinition": "partner in",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "partners in",
        "match_case": false,
        "keylookup": [
            "-llgun",
            0
        ]
    },
    "\u2013lqurrar*[V\u2192N]": {
        "exp": "\u2013lqurrar*[V\u2192N]",
        "exp_display": "\u2013lqurrar*",
        "description": "the one(s) most V",
        "singularDefinition": "most",
        "type": "VN",
        "pluralDefinition": "most",
        "match_case": false,
        "keylookup": [
            "-lqurraq*",
            0
        ]
    },
    "@:(u)te[V\u2192N]": {
        "exp": "@%:(u)te[V\u2192N]",
        "exp_display": "@\u00b3%:(u)te",
        "description": "(also @\u00b3(u)taq) instrument or device for V-ing; time of V-ing",
        "singularDefinition": "instrument or device for",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "instruments or devices for",
        "match_case": false,
        "keylookup": [
            "@(u)n,@(u)taq",
            0
        ]
    },
    "@~+natkar[V\u2192N]": {
        "exp": "@~+natkar[V\u2192N]",
        "exp_display": "@\u00b9~+natkar",
        "description": "future time of V-ing",
        "singularDefinition": "future time of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "future times of",
        "match_case": false,
        "keylookup": [
            "@~+natkaq",
            0
        ]
    },
    "@~+ner\u00b9[V\u2192N]": {
        "exp": "@~+ner\u00b9[V\u2192N]",
        "exp_display": "@\u2075~+ner",
        "description": "thing that results from V-ing",
        "singularDefinition": "thing that results from",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "things that result from",
        "match_case": false,
        "keylookup": [
            "@~+neq\u00b9",
            0
        ]
    },
    "@\u2013ner\u00b2[V\u2192N]": {
        "exp": "@\u2013ner\u00b2[V\u2192N]",
        "exp_display": "@\u00b9\u2013ner",
        "description": "the activity, art, or process of V-ing",
        "singularDefinition": "activity, art, or process of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "activities, arts, or processes of",
        "match_case": false,
        "keylookup": [
            "@-neq\u00b2",
            0
        ]
    },
    "\u2013ner\u00b3[V\u2192N]": {
        "exp": "\u2013ner\u00b3[V\u2192N]",
        "exp_display": "\u2013ner",
        "description": "one more V than possessor(s); the most V of possessors",
        "singularDefinition": "more (compared to possessor)",
        "type": "VN",
        "pluralDefinition": "more (compared to possessor)",
        "match_case": false,
        "keylookup": [
            "-neq\u00b3",
            0
        ]
    },
    "\u2013nerrar*[V\u2192N]": {
        "exp": "\u2013nerrar*[V\u2192N]",
        "exp_display": "\u2013nerrar*",
        "description": "new N; one that has recently V-ed",
        "singularDefinition": "who has recently",
        "type": "VN",
        "verbType": "past",
        "pluralDefinition": "that have recently",
        "match_case": false,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            6
        ]
    },
    "\u2013nerrar(ar*)[V\u2192N]": {
        "exp": "\u2013nerrar(ar*)[V\u2192N]",
        "exp_display": "\u2013nerrar(ar*)",
        "description": "new N; one that has recently V-ed",
        "singularDefinition": "who has recently",
        "type": "VN",
        "verbType": "past",
        "pluralDefinition": "that have recently",
        "match_case": false,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            7
        ]
    },
    "\u2013nerar(ar*)[V\u2192N]": {
        "exp": "\u2013nerar(ar*)[V\u2192N]",
        "exp_display": "\u2013nerar(ar*)",
        "description": "(NUN form) new N; one that has recently V-ed",
        "singularDefinition": "who has recently",
        "type": "VN",
        "verbType": "past",
        "pluralDefinition": "that have recently",
        "match_case": false,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            8
        ]
    },
    "@~+ngalngur*[V\u2192N]": {
        "exp": "@~+ngalngur*[V\u2192N]",
        "exp_display": "@\u00b2~+ngalngur*",
        "description": "one that seems to be V-ing",
        "singularDefinition": "who seems to be",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "that seem to be",
        "match_case": false,
        "keylookup": [
            "@~+ngalnguq*,+ngalnguq*",
            0
        ]
    },
    "\u2013ngssag[V\u2192N]": {
        "exp": "\u2013ngssag[V\u2192N]",
        "exp_display": "\u2013ngssag",
        "description": "small non-vital V-ing",
        "singularDefinition": "small non-vital",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "small non-vital",
        "match_case": false,
        "keylookup": [
            "-ngssak,-ngssag-",
            1
        ]
    },
    "\u2013nguar[V\u2192N]": {
        "exp": "\u2013nguar[V\u2192N]",
        "exp_display": "\u2013nguar",
        "description": "imitation N; inauthentic N; thing similar to or reminiscent of N; device for inauthentic V-ing",
        "singularDefinition": "device for inauthentic",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for inauthentic",
        "match_case": false,
        "keylookup": [
            "-nguaq,@~-nguar-",
            2
        ]
    },
    "\u2013nqegcaar(ar*)[V\u2192N]": {
        "exp": "\u2013nqegcaar(ar*)[V\u2192N]",
        "exp_display": "\u2013nqegcaar(ar*)",
        "description": "one who Vs thoroughly",
        "singularDefinition": "who thoroughly",
        "type": "VN",
        "verbType": "i",
        "pluralDefinition": "that thoroughly",
        "match_case": false,
        "keylookup": [
            "-nqegcaar(aq*),-nqegcaar(ar)-",
            1
        ]
    },
    "\u2013nqurrar*[V\u2192N]": {
        "exp": "\u2013nqurrar*[V\u2192N]",
        "exp_display": "\u2013nqurrar*",
        "description": "the one(s) most V",
        "singularDefinition": "most",
        "type": "VN",
        "pluralDefinition": "most",
        "match_case": false,
        "keylookup": [
            "-nqurraq*",
            0
        ]
    },
    "\u2013piar[V\u2192N]": {
        "exp": "\u2013piar[V\u2192N]",
        "exp_display": "\u2013piar",
        "description": "to be really V; to be very V (pg. 404 blue: TODO)",
        "singularDefinition": "who is really",
        "type": "VN",
        "pluralDefinition": "that are really",
        "match_case": false,
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            6
        ]
    },
    "@+piiner|~viiner[V\u2192N]": {
        "exp": "@+piiner|~viiner[V\u2192N]",
        "exp_display": "@\u2075+p|~viiner",
        "description": "incident of V-ing",
        "singularDefinition": "incident of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "incidents of",
        "match_case": false,
        "keylookup": [
            "@+piineq|~viineq",
            0
        ]
    },
    "\u2013qetaar[V\u2192N]": {
        "exp": "\u2013qetaar[V\u2192N]",
        "exp_display": "\u2013q\u0332etaar",
        "description": "device that alternately Vs and does the reverse",
        "singularDefinition": "device that alternately (and in reverse)",
        "type": "VN",
        "verbType": "present",
        "pluralDefinition": "devices that alternately (and in reverse)",
        "match_case": false,
        "keylookup": [
            "-qetaaq,-qetaar-",
            1
        ]
    },
    "\u2013rraaner[V\u2192N]": {
        "exp": "\u2013rraaner[V\u2192N]",
        "exp_display": "\u2013r\u0332r\u0332aaner",
        "description": "past time of V-ing",
        "singularDefinition": "past time of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "past times of",
        "match_case": false,
        "keylookup": [
            "-rraaneq",
            0
        ]
    },
    "+ssuute[V\u2192N]": {
        "exp": "+ssuute[V\u2192N]",
        "exp_display": "+ssuute",
        "description": "device for V-ing; device associated with N",
        "singularDefinition": "device for",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for",
        "match_case": false,
        "keylookup": [
            "+ssuun",
            0
        ]
    },
    "+(s)te[V\u2192N]": {
        "exp": "+(s)te[V\u2192N]",
        "exp_display": "+(s)te",
        "description": "V-er; one who Vs as an occupation (with unpossessed ending);",
        "singularDefinition": "who (or by occupation)",
        "type": "VN",
        "verbType": "i",
        "pluralDefinition": "that (or by occupation)",
        "match_case": false,
        "keylookup": [
            "+(s)ta",
            0
        ]
    },
    "@+tacir[V\u2192N]": {
        "exp": "@+tacir[V\u2192N]",
        "exp_display": "@\u00b2+tacir",
        "description": "extent of possessor\u02bcs V-ing",
        "singularDefinition": "extent of possessor's",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "extents of possessor's",
        "match_case": false,
        "keylookup": [
            "@+taciq",
            0
        ]
    },
    "@:(u)tar\u00b9[V\u2192N]": {
        "exp": "@%:(u)tar\u00b9[V\u2192N]",
        "exp_display": "@\u00b3%:(u)tar",
        "description": "device for V-ing",
        "singularDefinition": "device for",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for",
        "match_case": false,
        "keylookup": [
            "@:(u)taq\u00b9",
            0
        ]
    },
    "@+tate[V\u2192N]": {
        "exp": "@+tate[V\u2192N]",
        "exp_display": "@\u00b2+tate",
        "description": "one that is V to the same extent as possessor",
        "singularDefinition": "who is (to the same extent as possessor)",
        "type": "VN",
        "pluralDefinition": "that are (to the same extent as possessor)",
        "match_case": false,
        "keylookup": [
            "@+tata\u1d49",
            0
        ]
    },
    "@:(u)tiir[V\u2192N]": {
        "exp": "@%:(u)tiir[V\u2192N]",
        "exp_display": "@\u00b3%:(u)tiir",
        "description": "celebration of V-ing",
        "singularDefinition": "celebration of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "celebrations of",
        "match_case": false,
        "keylookup": [
            "@:(u)tiiq",
            0
        ]
    },
    "~:(u)tnguarkar[V\u2192N]": {
        "exp": "~%:(u)tnguarkar[V\u2192N]",
        "exp_display": "~%:(u)tnguarkar",
        "description": "potential/necessary aid to V-ing",
        "singularDefinition": "potential or necessary aid to",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "potential or necessary aids to",
        "match_case": false,
        "keylookup": [
            "~:(u)tnguarkaq",
            0
        ]
    },
    "\u2013tuke[V\u2192N]": {
        "exp": "\u2013tuke[V\u2192N]",
        "exp_display": "\u2013tuke",
        "description": "possessor\u02bcs normal, regular, or customary one to V",
        "singularDefinition": "possessor's regular or customary thing to",
        "type": "VN",
        "verbType": "i",
        "pluralDefinition": "possessor's regular or customary things to",
        "match_case": false,
        "keylookup": [
            "-tuka\u1d49",
            0
        ]
    },
    "\u2013tuli[V\u2192N]": {
        "exp": "\u2013tuli[V\u2192N]",
        "exp_display": "\u2013tuli",
        "description": "one that customarily Vs; one that is fully capable of V-ing",
        "singularDefinition": "who is fully capable of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "that are fully capable of",
        "match_case": false,
        "keylookup": [
            "+tuli,-tuli",
            1
        ]
    },
    "+(ng)uar[V\u2192N]": {
        "exp": "+(ng)uar[V\u2192N]",
        "exp_display": "+(ng)uar",
        "description": "imitation N; inauthentic N; thing similar to or reminiscent of N; device for inauthentic V-ing",
        "singularDefinition": "device for inauthentic",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for inauthentic",
        "match_case": false,
        "keylookup": [
            "+(ng)uaq,@~+(ng)uar-",
            2
        ]
    },
    "@~+vig[V\u2192N]": {
        "exp": "@~+vig[V\u2192N]",
        "exp_display": "@\u00b2~+vig",
        "description": "place to V; place or time of V-ing",
        "singularDefinition": "place to",
        "type": "VN",
        "verbType": "i",
        "pluralDefinition": "places to",
        "match_case": false,
        "keylookup": [
            "@~+vik,+(r)vik",
            0
        ]
    },
    "+(r)vig[V\u2192N]": {
        "exp": "+(r)vig[V\u2192N]",
        "exp_display": "+(r)vig",
        "description": "place for N",
        "singularDefinition": "place for",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "places for",
        "match_case": false,
        "keylookup": [
            "@~+vik,+(r)vik",
            1
        ]
    },
    "@~+yailkutar[V\u2192N]": {
        "exp": "@~+yailkutar[V\u2192N]",
        "exp_display": "@\u02b8~+yailkutar",
        "description": "device to prevent V-ing",
        "singularDefinition": "device for preventing",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for preventing",
        "match_case": false,
        "keylookup": [
            "@~+yailkutaq,@~+yailkun",
            0
        ]
    },
    "@~+yailkute[V\u2192N]": {
        "exp": "@~+yailkute[V\u2192N]",
        "exp_display": "@\u02b8~+yailkute",
        "description": "device to prevent V-ing",
        "singularDefinition": "device for preventing",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "devices for preventing",
        "match_case": false,
        "keylookup": [
            "@~+yailkutaq,@~+yailkun",
            1
        ]
    },
    "+yag[V\u2192N]": {
        "exp": "+yag[V\u2192N]",
        "exp_display": "+yag",
        "description": "thing similar to N; thing that acts as if it were V; small N",
        "singularDefinition": "thing that act as if it were",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "things that act as if they were",
        "match_case": false,
        "keylookup": [
            "+yak",
            1
        ]
    },
    "@~+yaller[V\u2192N]": {
        "exp": "@~+yaller[V\u2192N]",
        "exp_display": "@\u02b8~+yaller",
        "description": "during the period of time when possessor is V-ing",
        "singularDefinition": "period of time when possessor is",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "periods of time when possessor is",
        "match_case": false,
        "keylookup": [
            "@~+yalleq",
            0
        ]
    },
    "@~+yarar[V\u2192N]": {
        "exp": "@~+yarar[V\u2192N]",
        "exp_display": "@\u02b8~+yarar",
        "description": "way of V-ing; how to V; method of V-ing; device for V-ing; way of or device for dealing with N",
        "singularDefinition": "way of",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "ways of",
        "match_case": false,
        "keylookup": [
            "@~+yaraq",
            1
        ]
    },
    "@~\u2013yuli[V\u2192N]": {
        "exp": "@~\u2013yuli[V\u2192N]",
        "exp_display": "@\u02b8~\u2013yuli",
        "description": "one who is good at V-ing: a proficient V-er",
        "singularDefinition": "who is good at",
        "type": "VN",
        "verbType": "g",
        "pluralDefinition": "that are good at",
        "match_case": false,
        "keylookup": [
            "@~-yuli",
            0
        ]
    },
    "@~+yunqeggli[V\u2192N]": {
        "exp": "@~+yunqeggli[V\u2192N]",
        "exp_display": "@\u02b8~+yunqeggli",
        "description": "one who loves to V; an avid V-er",
        "singularDefinition": "who loves to",
        "type": "VN",
        "verbType": "i",
        "pluralDefinition": "that love to",
        "match_case": false,
        "keylookup": [
            "@~+yunqeggli",
            0
        ]
    },
    "\u2013ar(ar*)[N\u2192N]": {
        "exp": "\u2013ar(ar*)[N\u2192N]",
        "exp_display": "\u2013ar(ar*)",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "little piece of",
        "pluralDefinition": "little pieces of",
        "postDefinition": "",
        "description": "little piece of",
        "match_case": false,
        "keylookup": [
            "-ar(aq*)",
            0
        ]
    },
    "\u2013ciller[N\u2192N]": {
        "exp": "\u2013ciller[N\u2192N]",
        "exp_display": "\u2013ciller",
        "type": "NN",
        "require": "",
        "singularDefinition": "worthless",
        "pluralDefinition": "worthless",
        "postDefinition": "",
        "description": "worthless",
        "match_case": true,
        "keylookup": [
            "-cilleq",
            0
        ]
    },
    "\u2013cuar(ar*)[N\u2192N]": {
        "exp": "\u2013cuar(ar*)[N\u2192N]",
        "exp_display": "\u2013cuar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "small",
        "pluralDefinition": "small",
        "postDefinition": "",
        "description": "small",
        "match_case": true,
        "keylookup": [
            "-cuar(aq*)",
            0
        ]
    },
    "\u2013cug[N\u2192N]": {
        "exp": "\u2013cug[N\u2192N]",
        "exp_display": "\u2013cug",
        "type": "NN",
        "require": "",
        "singularDefinition": "unpleasing",
        "pluralDefinition": "unpleasing",
        "postDefinition": "",
        "description": "unpleasing",
        "match_case": true,
        "keylookup": [
            "-cuk",
            0
        ]
    },
    "\u2013cungar[N\u2192N]": {
        "exp": "\u2013cungar[N\u2192N]",
        "exp_display": "\u2013cungar",
        "type": "NN",
        "require": "",
        "singularDefinition": "cute little",
        "pluralDefinition": "cute little",
        "postDefinition": "",
        "description": "cute little",
        "match_case": true,
        "keylookup": [
            "-cungaq",
            0
        ]
    },
    ":(ng)inar*[N\u2192N]": {
        "exp": "%:(ng)inar*[N\u2192N]",
        "exp_display": "%:(ng)inar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "mere (and nothing more)",
        "pluralDefinition": "mere (and nothing more)",
        "postDefinition": "",
        "description": "mere (and nothing more)",
        "match_case": true,
        "keylookup": [
            ":(ng)inaq*",
            0
        ]
    },
    ":(ng)i:rute[N\u2192N]": {
        "exp": "%:(ng)i%:rute[N\u2192N]",
        "exp_display": "%:(ng)i%:rute",
        "type": "NN",
        "require": "",
        "singularDefinition": "late (deceased)",
        "pluralDefinition": "late (deceased)",
        "postDefinition": "",
        "description": "late (deceased)",
        "match_case": true,
        "keylookup": [
            ":(ng)i:run",
            0
        ]
    },
    "\u2013kainer[N\u2192N]": {
        "exp": "\u2013kainer[N\u2192N]",
        "exp_display": "\u2013kainer",
        "type": "NN",
        "require": "",
        "singularDefinition": "little bit of",
        "pluralDefinition": "little bits of",
        "postDefinition": "",
        "description": "little bit of",
        "match_case": false,
        "keylookup": [
            "-kaineq",
            0
        ]
    },
    "+kar[N\u2192N]": {
        "exp": "+kar[N\u2192N]",
        "exp_display": "+kar",
        "type": "NN",
        "require": "",
        "singularDefinition": "future",
        "pluralDefinition": "future",
        "postDefinition": "",
        "description": "future",
        "match_case": true,
        "keylookup": [
            "+kaq",
            0
        ]
    },
    "@kar(ar*)\u00b9[N\u2192N]": {
        "exp": "@kar(ar*)\u00b9[N\u2192N]",
        "exp_display": "@\u2075kar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "small",
        "pluralDefinition": "small",
        "postDefinition": "",
        "description": "small",
        "match_case": true,
        "keylookup": [
            "@kar(aq*)\u00b9",
            0
        ]
    },
    "\u2013kcag[N\u2192N]": {
        "exp": "\u2013kcag[N\u2192N]",
        "exp_display": "\u2013kcag",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "thing that looks like a",
        "pluralDefinition": "things that looks like a",
        "postDefinition": "",
        "description": "thing that looks like a",
        "match_case": false,
        "keylookup": [
            "-kcak",
            0
        ]
    },
    "\u2013kcuar(ar*)[N\u2192N]": {
        "exp": "\u2013kcuar(ar*)[N\u2192N]",
        "exp_display": "\u2013kcuar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "small",
        "pluralDefinition": "small",
        "postDefinition": "",
        "description": "small",
        "match_case": true,
        "keylookup": [
            "-kcuar(aq*)",
            0
        ]
    },
    "\u2013kegtaar(ar*)[N\u2192N]": {
        "exp": "\u2013kegtaar(ar*)[N\u2192N]",
        "exp_display": "\u2013kegtaar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "good",
        "pluralDefinition": "good",
        "postDefinition": "",
        "description": "good",
        "match_case": true,
        "keylookup": [
            "-kegtaar(aq*)",
            1
        ]
    },
    "@\u2013ksagar[N\u2192N]": {
        "exp": "@\u2013ksagar[N\u2192N]",
        "exp_display": "@\u2075\u2013ksagar",
        "type": "NN",
        "require": "",
        "singularDefinition": "very ugly",
        "pluralDefinition": "very ugly",
        "postDefinition": "",
        "description": "very ugly",
        "match_case": true,
        "keylookup": [
            "@-ksagaq",
            0
        ]
    },
    "@ksuar(ar*)[N\u2192N]": {
        "exp": "@ksuar(ar*)[N\u2192N]",
        "exp_display": "@\u2075ksuar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "small",
        "pluralDefinition": "small",
        "postDefinition": "",
        "description": "small",
        "match_case": true,
        "keylookup": [
            "@ksuar(aq*)",
            0
        ]
    },
    "+kuar[N\u2192N]": {
        "exp": "+kuar[N\u2192N]",
        "exp_display": "+kuar",
        "type": "NN",
        "require": "",
        "singularDefinition": "leftover",
        "pluralDefinition": "leftover",
        "postDefinition": "",
        "description": "leftover",
        "match_case": true,
        "keylookup": [
            "+kuaq",
            0
        ]
    },
    "\u2013kucir[N\u2192N]": {
        "exp": "\u2013kucir[N\u2192N]",
        "exp_display": "\u2013kucir",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "of the same kind as",
        "pluralDefinition": "of the same kind as",
        "postDefinition": "",
        "description": "of the same kind as",
        "match_case": false,
        "keylookup": [
            "-kuciq",
            1
        ]
    },
    "\u2013kuiner(ar*)[N\u2192N]": {
        "exp": "\u2013kuiner(ar*)[N\u2192N]",
        "exp_display": "\u2013kuiner(ar*)",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "small amount of",
        "pluralDefinition": "small amounts of",
        "postDefinition": "",
        "description": "small amount of",
        "match_case": false,
        "keylookup": [
            "-kuiner(aq*),-kuinr(aq*),-kuineq",
            0
        ]
    },
    "\u2013kuinr(ar*)[N\u2192N]": {
        "exp": "\u2013kuinr(ar*)[N\u2192N]",
        "exp_display": "\u2013kuinr(ar*)",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "small amount of",
        "pluralDefinition": "small amounts of",
        "postDefinition": "",
        "description": "small amount of",
        "match_case": false,
        "keylookup": [
            "-kuiner(aq*),-kuinr(aq*),-kuineq",
            1
        ]
    },
    "\u2013kuiner[N\u2192N]": {
        "exp": "\u2013kuiner[N\u2192N]",
        "exp_display": "\u2013kuiner",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "small amount of",
        "pluralDefinition": "small amounts of",
        "postDefinition": "",
        "description": "small amount of",
        "match_case": false,
        "keylookup": [
            "-kuiner(aq*),-kuinr(aq*),-kuineq",
            2
        ]
    },
    "\u2013kutar[N\u2192N]": {
        "exp": "\u2013kutar[N\u2192N]",
        "exp_display": "\u2013k\u0332utar",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "thing to be used as one would with",
        "pluralDefinition": "things to be used as one would with",
        "postDefinition": "",
        "description": "thing to be used as one would with",
        "match_case": false,
        "keylookup": [
            "-kutaq,-kun",
            0
        ]
    },
    "\u2013kute[N\u2192N]": {
        "exp": "\u2013kute[N\u2192N]",
        "exp_display": "\u2013kute",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "thing to be used as one would with",
        "pluralDefinition": "things to be used as one would with",
        "postDefinition": "",
        "description": "thing to be used as one would with",
        "match_case": false,
        "keylookup": [
            "-kutaq,-kun",
            1
        ]
    },
    "\u2013kuyug[N\u2192N]": {
        "exp": "\u2013kuyug[N\u2192N]",
        "exp_display": "\u2013kuyug",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "small bit of",
        "pluralDefinition": "small bits of",
        "postDefinition": "",
        "description": "small bit of",
        "match_case": false,
        "keylookup": [
            "-kuyuk,-kuyugaq",
            0
        ]
    },
    "\u2013kuyugar[N\u2192N]": {
        "exp": "\u2013kuyugar[N\u2192N]",
        "exp_display": "\u2013kuyugar",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "small bit of",
        "pluralDefinition": "small bits of",
        "postDefinition": "",
        "description": "small bit of",
        "match_case": false,
        "keylookup": [
            "-kuyuk,-kuyugaq",
            1
        ]
    },
    "\u2013leg[N\u2192N]": {
        "exp": "\u2013leg[N\u2192N]",
        "exp_display": "\u2013leg",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "with",
        "pluralDefinition": "with",
        "postDefinition": "",
        "description": "with",
        "match_case": false,
        "keylookup": [
            "-lek",
            0
        ]
    },
    "\u2013lgute[N\u2192N]": {
        "exp": "\u2013lgute[N\u2192N]",
        "exp_display": "\u2013lgute",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "sharer of",
        "pluralDefinition": "sharers of",
        "postDefinition": "",
        "description": "sharer of",
        "match_case": false,
        "keylookup": [
            "-lgun",
            0
        ]
    },
    "+li\u00b9[N\u2192N]": {
        "exp": "+li\u00b9[N\u2192N]",
        "exp_display": "+li",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "similar to",
        "pluralDefinition": "similar to",
        "postDefinition": "",
        "description": "similar to",
        "match_case": true,
        "keylookup": [
            "+li\u00b9,+liq",
            0
        ]
    },
    "+lir[N\u2192N]": {
        "exp": "+lir[N\u2192N]",
        "exp_display": "+lir",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "similar to",
        "pluralDefinition": "similar to",
        "postDefinition": "",
        "description": "similar to",
        "match_case": true,
        "keylookup": [
            "+li\u00b9,+liq",
            1
        ]
    },
    "\u2013\u2013liar[N\u2192N]": {
        "exp": "\u2013\u2013liar[N\u2192N]",
        "exp_display": "\u2013\u2013liar",
        "type": "NN",
        "require": "",
        "singularDefinition": "made",
        "pluralDefinition": "made",
        "postDefinition": "",
        "description": "made",
        "match_case": true,
        "keylookup": [
            "-liaq",
            0
        ]
    },
    "\u2013\u2013linrar*[N\u2192N]": {
        "exp": "\u2013\u2013linrar*[N\u2192N]",
        "exp_display": "\u2013\u2013linrar*",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "product of",
        "pluralDefinition": "products of",
        "postDefinition": "",
        "description": "product of",
        "match_case": false,
        "keylookup": [
            "-linraq*,-linr(aq*)",
            0
        ]
    },
    "\u2013\u2013linr(ar*)[N\u2192N]": {
        "exp": "\u2013\u2013linr(ar*)[N\u2192N]",
        "exp_display": "\u2013\u2013linr(ar*)",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "product of",
        "pluralDefinition": "products of",
        "postDefinition": "",
        "description": "product of",
        "match_case": false,
        "keylookup": [
            "-linraq*,-linr(aq*)",
            1
        ]
    },
    "\u2013lkug[N\u2192N]": {
        "exp": "\u2013lkug[N\u2192N]",
        "exp_display": "\u2013lkug",
        "type": "NN",
        "require": "",
        "singularDefinition": "no-good",
        "pluralDefinition": "no-good",
        "postDefinition": "",
        "description": "no-good",
        "match_case": true,
        "keylookup": [
            "-lkuk,-lkug-",
            0
        ]
    },
    "\u2013llar*[N\u2192N]": {
        "exp": "\u2013llar*[N\u2192N]",
        "exp_display": "\u2013llar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "",
        "pluralDefinition": "",
        "postDefinition": "(with reference to the past)",
        "description": "(with reference to the past)",
        "match_case": false,
        "keylookup": [
            "-llaq*",
            0
        ]
    },
    "\u2013ller(ar*)[N\u2192N]": {
        "exp": "\u2013ller(ar*)[N\u2192N]",
        "exp_display": "\u2013ller(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "shabby old",
        "pluralDefinition": "shabby old",
        "postDefinition": "",
        "description": "shabby old",
        "match_case": true,
        "keylookup": [
            "-ller(aq*)",
            0
        ]
    },
    "@\u2013llug[N\u2192N]": {
        "exp": "@\u2013llug[N\u2192N]",
        "exp_display": "@\u2075\u2013llug",
        "type": "NN",
        "require": "",
        "singularDefinition": "bad",
        "pluralDefinition": "bad",
        "postDefinition": "",
        "description": "bad",
        "match_case": true,
        "keylookup": [
            "@-lluk,-llug-,-llugte-",
            0
        ]
    },
    "\u2013lqur[N\u2192N]": {
        "exp": "\u2013lqur[N\u2192N]",
        "exp_display": "\u2013lqur",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "old broken piece of",
        "pluralDefinition": "old broken pieces of",
        "postDefinition": "",
        "description": "old broken piece of",
        "match_case": false,
        "keylookup": [
            "-lquq",
            0
        ]
    },
    "\u2013luatar[N\u2192N]": {
        "exp": "\u2013luatar[N\u2192N]",
        "exp_display": "\u2013luatar",
        "type": "NN",
        "require": "",
        "singularDefinition": "good",
        "pluralDefinition": "good",
        "postDefinition": "",
        "description": "good",
        "match_case": true,
        "keylookup": [
            "-luataq,-luatar-",
            0
        ]
    },
    "\u2013lugpiar[N\u2192N]": {
        "exp": "\u2013lugpiar[N\u2192N]",
        "exp_display": "\u2013lugpiar",
        "type": "NN",
        "require": "",
        "singularDefinition": "original",
        "pluralDefinition": "original",
        "postDefinition": "",
        "description": "original",
        "match_case": true,
        "keylookup": [
            "-lugpiaq",
            0
        ]
    },
    "+mig[N\u2192N]": {
        "exp": "+mig[N\u2192N]",
        "exp_display": "+mig",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "thing held in ^one's^",
        "pluralDefinition": "things held in ^one's^",
        "postDefinition": "",
        "description": "thing held in ^one's^",
        "match_case": false,
        "keylookup": [
            "+mik,+miaq,+mig-",
            0
        ]
    },
    "+miar[N\u2192N]": {
        "exp": "+miar[N\u2192N]",
        "exp_display": "+miar",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "thing held in ^one's^",
        "pluralDefinition": "things held in ^one's^",
        "postDefinition": "",
        "description": "thing held in ^one's^",
        "match_case": false,
        "keylookup": [
            "+mik,+miaq,+mig-",
            1
        ]
    },
    "~+miu[N\u2192N]": {
        "exp": "~+miu[N\u2192N]",
        "exp_display": "~+miu",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "inhabitant of",
        "pluralDefinition": "inhabitants of",
        "postDefinition": "",
        "description": "inhabitant of",
        "match_case": false,
        "keylookup": [
            "~+miu",
            0
        ]
    },
    "~+miutar*[N\u2192N]": {
        "exp": "~+miutar*[N\u2192N]",
        "exp_display": "~+miutar*",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "whose place is",
        "pluralDefinition": "whose place is",
        "postDefinition": "",
        "description": "whose place is",
        "match_case": false,
        "keylookup": [
            "~+miutaq*",
            0
        ]
    },
    "+ner\u2074[N\u2192N]": {
        "exp": "+ner\u2074[N\u2192N]",
        "exp_display": "+ner",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "area of",
        "pluralDefinition": "areas of",
        "postDefinition": "",
        "description": "area of",
        "match_case": false,
        "keylookup": [
            "+neq\u2074",
            0
        ]
    },
    "\u2013nerrar*[N\u2192N]": {
        "exp": "\u2013nerrar*[N\u2192N]",
        "exp_display": "\u2013nerrar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "new",
        "pluralDefinition": "new",
        "postDefinition": "",
        "description": "new",
        "match_case": true,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            0
        ]
    },
    "\u2013nerrar(ar*)[N\u2192N]": {
        "exp": "\u2013nerrar(ar*)[N\u2192N]",
        "exp_display": "\u2013nerrar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "new",
        "pluralDefinition": "new",
        "postDefinition": "",
        "description": "new",
        "match_case": true,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            1
        ]
    },
    "\u2013nerar(ar*)[N\u2192N]": {
        "exp": "\u2013nerar(ar*)[N\u2192N]",
        "exp_display": "\u2013nerar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "new",
        "pluralDefinition": "new",
        "postDefinition": "",
        "description": "new",
        "match_case": true,
        "keylookup": [
            "-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",
            2
        ]
    },
    "\u2013ngirta'rrlugar*[N\u2192N]": {
        "exp": "\u2013ngirta'rrlugar*[N\u2192N]",
        "exp_display": "\u2013ngirta'rrlugar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "good old (but perhaps decrepit)",
        "pluralDefinition": "good old (but perhaps decrepit)",
        "postDefinition": "",
        "description": "good old (but perhaps decrepit)",
        "match_case": true,
        "keylookup": [
            "-ngirta'rrlugaq*",
            0
        ]
    },
    "\u2013ngnagar[N\u2192N]": {
        "exp": "\u2013ngnagar[N\u2192N]",
        "exp_display": "\u2013ngnagar",
        "type": "NN",
        "require": "",
        "singularDefinition": "poor quality",
        "pluralDefinition": "poor quality",
        "postDefinition": "",
        "description": "poor quality",
        "match_case": true,
        "keylookup": [
            "-ngnagaq,-ngnagar-",
            0
        ]
    },
    "\u2013ngssaar(ar*)[N\u2192N]": {
        "exp": "\u2013ngssaar(ar*)[N\u2192N]",
        "exp_display": "\u2013ngssaar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "secret",
        "pluralDefinition": "secret",
        "postDefinition": "",
        "description": "secret",
        "match_case": true,
        "keylookup": [
            "-ngssaar(aq*),-ngssaar(ar)-",
            0
        ]
    },
    "\u2013nguar[N\u2192N]": {
        "exp": "\u2013nguar[N\u2192N]",
        "exp_display": "\u2013nguar",
        "type": "NN",
        "require": "",
        "singularDefinition": "fake",
        "pluralDefinition": "fake",
        "postDefinition": "",
        "description": "fake",
        "match_case": true,
        "keylookup": [
            "-nguaq,@~-nguar-",
            0
        ]
    },
    "\u2013ngyaar(ar*)[N\u2192N]": {
        "exp": "\u2013ngyaar(ar*)[N\u2192N]",
        "exp_display": "\u2013ngyaar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "old (person)",
        "pluralDefinition": "old (person)",
        "postDefinition": "",
        "description": "old (person)",
        "match_case": true,
        "keylookup": [
            "-ngyaar(aq*),-ngiar(aq*)",
            0
        ]
    },
    "\u2013ngiar(ar*)[N\u2192N]": {
        "exp": "\u2013ngiar(ar*)[N\u2192N]",
        "exp_display": "\u2013ngiar(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "old (person)",
        "pluralDefinition": "old (person)",
        "postDefinition": "",
        "description": "old (person)",
        "match_case": true,
        "keylookup": [
            "-ngyaar(aq*),-ngiar(aq*)",
            1
        ]
    },
    "+nir\u00b2[N\u2192N]": {
        "exp": "+nir\u00b2[N\u2192N]",
        "exp_display": "+nir",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "smell of",
        "pluralDefinition": "smells of",
        "postDefinition": "",
        "description": "smell of",
        "match_case": false,
        "keylookup": [
            "+niq\u00b2",
            0
        ]
    },
    "\u2013paarrlug[N\u2192N]": {
        "exp": "\u2013paarrlug[N\u2192N]",
        "exp_display": "\u2013paarrlug",
        "type": "NN",
        "require": "",
        "singularDefinition": "big",
        "pluralDefinition": "big",
        "postDefinition": "",
        "description": "big",
        "match_case": true,
        "keylookup": [
            "-paarrluk",
            0
        ]
    },
    "\u2013pig\u00b9[N\u2192N]": {
        "exp": "\u2013pig\u00b9[N\u2192N]",
        "exp_display": "\u2013pig",
        "type": "NN",
        "require": "",
        "singularDefinition": "genuine",
        "pluralDefinition": "genuine",
        "postDefinition": "",
        "description": "genuine",
        "match_case": true,
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            0
        ]
    },
    "\u2013piar[N\u2192N]": {
        "exp": "\u2013piar[N\u2192N]",
        "exp_display": "\u2013piar",
        "type": "NN",
        "require": "",
        "singularDefinition": "genuine",
        "pluralDefinition": "genuine",
        "postDefinition": "",
        "description": "genuine",
        "match_case": true,
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            1
        ]
    },
    "\u2013pigar[N\u2192N]": {
        "exp": "\u2013pigar[N\u2192N]",
        "exp_display": "\u2013pigar",
        "type": "NN",
        "require": "",
        "singularDefinition": "genuine",
        "pluralDefinition": "genuine",
        "postDefinition": "",
        "description": "genuine",
        "match_case": true,
        "keylookup": [
            "-pik\u00b9,-piaq,-pigaq,-pig-,-piar-,-pigar-",
            2
        ]
    },
    "\u2013qainar[N\u2192N]": {
        "exp": "\u2013qainar[N\u2192N]",
        "exp_display": "\u2013q\u0332ainar",
        "type": "NN",
        "require": "",
        "singularDefinition": "mere",
        "pluralDefinition": "mere",
        "postDefinition": "",
        "description": "mere",
        "match_case": true,
        "keylookup": [
            "-qainaq,-qainar-",
            0
        ]
    },
    "\u2013qtar*[N\u2192N]": {
        "exp": "\u2013qtar*[N\u2192N]",
        "exp_display": "\u2013q\u0332tar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "weak helpless",
        "pluralDefinition": "weak helpless",
        "postDefinition": "",
        "description": "weak helpless",
        "match_case": true,
        "keylookup": [
            "-qtaq*,-qtar-",
            0
        ]
    },
    "\u2013qva[N\u2192N]": {
        "exp": "\u2013qva[N\u2192N]",
        "exp_display": "\u2013q\u0332va",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "area far in the direction of",
        "pluralDefinition": "areas far in the direction of",
        "postDefinition": "",
        "description": "area far in the direction of",
        "match_case": false,
        "keylookup": [
            "-qva",
            2
        ]
    },
    "\u2013qvaar*[N\u2192N]": {
        "exp": "\u2013qvaar*[N\u2192N]",
        "exp_display": "\u2013q\u0332vaar*",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "area far in the direction of",
        "pluralDefinition": "areas far in the direction of",
        "postDefinition": "",
        "description": "area far in the direction of",
        "match_case": false,
        "keylookup": [
            "-qvaaq*",
            2
        ]
    },
    "\u2013r'aya'ar[N\u2192N]": {
        "exp": "\u2013r'aya'ar[N\u2192N]",
        "exp_display": "\u2013r\u0332'aya'ar",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "multitude of",
        "pluralDefinition": "multitudes of",
        "postDefinition": "",
        "description": "multitude of",
        "match_case": false,
        "keylookup": [
            "-r'aya'aq",
            0
        ]
    },
    "\u2013rpaa(ar*)[N\u2192N]": {
        "exp": "\u2013rpaa(ar*)[N\u2192N]",
        "exp_display": "\u2013r\u0332paa(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "great",
        "pluralDefinition": "great",
        "postDefinition": "",
        "description": "great",
        "match_case": true,
        "keylookup": [
            "-rpaa(aq*)",
            0
        ]
    },
    "\u2013rpag|@vag[N\u2192N]": {
        "exp": "\u2013rpag|@vag[N\u2192N]",
        "exp_display": "\u2013r\u0332pag|@\u00b2vag",
        "type": "NN",
        "require": "",
        "singularDefinition": "large",
        "pluralDefinition": "large",
        "postDefinition": "",
        "description": "large",
        "match_case": true,
        "keylookup": [
            "@vak|?vak",
            0
        ]
    },
    "\u2013rpallr(ar*)[N\u2192N]": {
        "exp": "\u2013rpallr(ar*)[N\u2192N]",
        "exp_display": "\u2013r\u0332pallr(ar*)",
        "type": "NN",
        "require": "",
        "singularDefinition": "very large",
        "pluralDefinition": "very large",
        "postDefinition": "",
        "description": "very large",
        "match_case": true,
        "keylookup": [
            "-rpallr(aq*)",
            0
        ]
    },
    "\u2013rrar*[N\u2192N]": {
        "exp": "\u2013rrar*[N\u2192N]",
        "exp_display": "\u2013r\u0332r\u0332ar*",
        "type": "NN",
        "require": "singularize",
        "singularDefinition": "little bit of",
        "pluralDefinition": "little bits of",
        "postDefinition": "",
        "description": "little bit of",
        "match_case": false,
        "keylookup": [
            "-rraq*,-rrar-",
            2
        ]
    },
    "\u2013rrlainar*[N\u2192N]": {
        "exp": "\u2013rrlainar*[N\u2192N]",
        "exp_display": "\u2013r\u0332r\u0332lainar*",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "area with nothing but",
        "pluralDefinition": "areas with nothing but",
        "postDefinition": "",
        "description": "area with nothing but",
        "match_case": false,
        "keylookup": [
            "-rrlainaq*,-rrlainar-",
            0
        ]
    },
    "\u2013rrlugar*[N\u2192N]": {
        "exp": "\u2013rrlugar*[N\u2192N]",
        "exp_display": "\u2013r\u0332r\u0332lugar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "good old",
        "pluralDefinition": "good old",
        "postDefinition": "",
        "description": "good old",
        "match_case": true,
        "keylookup": [
            "-rrlugaq*",
            0
        ]
    },
    "\u2013rrlug[N\u2192N]": {
        "exp": "\u2013rrlug[N\u2192N]",
        "exp_display": "\u2013r\u0332r\u0332lug",
        "type": "NN",
        "require": "",
        "singularDefinition": "",
        "pluralDefinition": "",
        "postDefinition": "that departed from a natural state (often undesirably)",
        "description": "that departed from a natural state (often undesirably)",
        "match_case": false,
        "keylookup": [
            "-rrluk,-rrlug-,-rrlugte-",
            0
        ]
    },
    "\u2013rugar*[N\u2192N]": {
        "exp": "\u2013rugar*[N\u2192N]",
        "exp_display": "\u2013r\u0332ugar*",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "multitudes of",
        "pluralDefinition": "multitudes of",
        "postDefinition": "",
        "description": "multitudes of",
        "match_case": false,
        "keylookup": [
            "-rugaq*",
            0
        ]
    },
    "\u2013r(ur)lur*[N\u2192N]": {
        "exp": "\u2013r(ur)lur*[N\u2192N]",
        "exp_display": "\u2013r\u0332(ur)lur*",
        "type": "NN",
        "require": "",
        "singularDefinition": "poor dear",
        "pluralDefinition": "poor dear",
        "postDefinition": "",
        "description": "poor dear",
        "match_case": true,
        "keylookup": [
            "-r(ur)luq*,-q(ur)lur-",
            3
        ]
    },
    "\u2013ssaarar[N\u2192N]": {
        "exp": "\u2013ssaarar[N\u2192N]",
        "exp_display": "\u2013ssaarar",
        "type": "NN",
        "require": "",
        "singularDefinition": "old",
        "pluralDefinition": "old",
        "postDefinition": "",
        "description": "old",
        "match_case": true,
        "keylookup": [
            "-ssaaraq",
            0
        ]
    },
    "+taleg[N\u2192N]": {
        "exp": "+taleg[N\u2192N]",
        "exp_display": "+taleg",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "place having",
        "pluralDefinition": "places having",
        "postDefinition": "",
        "description": "place having",
        "match_case": false,
        "keylookup": [
            "+talek",
            0
        ]
    },
    "+tar\u00b2[N\u2192N]": {
        "exp": "+tar\u00b2[N\u2192N]",
        "exp_display": "+tar",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "thing pertaining to",
        "pluralDefinition": "things pertaining to",
        "postDefinition": "",
        "description": "thing pertaining to",
        "match_case": false,
        "keylookup": [
            "+taq\u00b2",
            0
        ]
    },
    "+tar\u00b3[N\u2192N]": {
        "exp": "+tar\u00b3[N\u2192N]",
        "exp_display": "+tar",
        "type": "NN",
        "require": "",
        "singularDefinition": "caught (game animal)",
        "pluralDefinition": "caught (game animals)",
        "postDefinition": "",
        "description": "caught (game animal)",
        "match_case": false,
        "keylookup": [
            "+taq\u00b3",
            0
        ]
    },
    "+tar\u2075[N\u2192N]": {
        "exp": "+tar\u2075[N\u2192N]",
        "exp_display": "+tar",
        "type": "NN",
        "require": "",
        "singularDefinition": "",
        "pluralDefinition": "",
        "postDefinition": "specifically",
        "description": "specifically",
        "match_case": false,
        "keylookup": [
            "+taq\u2075",
            0
        ]
    },
    "+tuli[N\u2192N]": {
        "exp": "+tuli[N\u2192N]",
        "exp_display": "+tuli",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "well endowed with",
        "pluralDefinition": "well endowed with",
        "postDefinition": "",
        "description": "well endowed with",
        "match_case": false,
        "keylookup": [
            "+tuli,-tuli",
            0
        ]
    },
    "+(ng)uar[N\u2192N]": {
        "exp": "+(ng)uar[N\u2192N]",
        "exp_display": "+(ng)uar",
        "type": "NN",
        "require": "",
        "singularDefinition": "imitation",
        "pluralDefinition": "imitation",
        "postDefinition": "",
        "description": "imitation",
        "match_case": true,
        "keylookup": [
            "+(ng)uaq,@~+(ng)uar-",
            0
        ]
    },
    ":(ng)ute[N\u2192N]": {
        "exp": "%:(ng)ute[N\u2192N]",
        "exp_display": "%:(ng)ute",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "supply of",
        "pluralDefinition": "supplies of",
        "postDefinition": "",
        "description": "supply of",
        "match_case": false,
        "keylookup": [
            ":(ng)un,:~(ng)un",
            0
        ]
    },
    ":~(ng)ute[N\u2192N]": {
        "exp": "%:~(ng)ute[N\u2192N]",
        "exp_display": "%:~(ng)ute",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "supply of",
        "pluralDefinition": "supplies of",
        "postDefinition": "",
        "description": "supply of",
        "match_case": false,
        "keylookup": [
            ":(ng)un,:~(ng)un",
            1
        ]
    },
    ":(ng)uteller[N\u2192N]": {
        "exp": "%:(ng)uteller[N\u2192N]",
        "exp_display": "%:(ng)uteller",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "empty container that held",
        "pluralDefinition": "empty containers that held",
        "postDefinition": "",
        "description": "empty container that held",
        "match_case": false,
        "keylookup": [
            ":(ng)utelleq,:~(ng)utelleq",
            0
        ]
    },
    ":~(ng)uteller[N\u2192N]": {
        "exp": "%:~(ng)uteller[N\u2192N]",
        "exp_display": "%:~(ng)uteller",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "empty container that held",
        "pluralDefinition": "empty containers that held",
        "postDefinition": "",
        "description": "empty container that held",
        "match_case": false,
        "keylookup": [
            ":(ng)utelleq,:~(ng)utelleq",
            1
        ]
    },
    "\u2013vaarrlug[N\u2192N]": {
        "exp": "\u2013vaarrlug[N\u2192N]",
        "exp_display": "\u2013vaarrlug",
        "type": "NN",
        "require": "",
        "singularDefinition": "big",
        "pluralDefinition": "big",
        "postDefinition": "",
        "description": "big",
        "match_case": true,
        "keylookup": [
            "-vaarrluk",
            0
        ]
    },
    "\u2013vialug[N\u2192N]": {
        "exp": "\u2013vialug[N\u2192N]",
        "exp_display": "\u2013vialug",
        "type": "NN",
        "require": "",
        "singularDefinition": "shabby",
        "pluralDefinition": "shabby",
        "postDefinition": "",
        "description": "shabby",
        "match_case": true,
        "keylookup": [
            "-vialuk,-vialug-",
            0
        ]
    },
    "@~+viutar[N\u2192N]": {
        "exp": "@~+viutar[N\u2192N]",
        "exp_display": "@\u00b2~+viutar",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "container for",
        "pluralDefinition": "containers for",
        "postDefinition": "",
        "description": "container for",
        "match_case": false,
        "keylookup": [
            "@~+viutaq",
            0
        ]
    },
    "\u2013ya(g)ar*[N\u2192N]": {
        "exp": "\u2013ya(g)ar*[N\u2192N]",
        "exp_display": "\u2013ya\u0121ar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "baby or little",
        "pluralDefinition": "baby or little",
        "postDefinition": "",
        "description": "baby or little",
        "match_case": true,
        "keylookup": [
            "-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",
            0
        ]
    },
    "\u2013yagar*[N\u2192N]": {
        "exp": "\u2013yagar*[N\u2192N]",
        "exp_display": "\u2013yagar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "baby or little",
        "pluralDefinition": "baby or little",
        "postDefinition": "",
        "description": "baby or little",
        "match_case": true,
        "keylookup": [
            "-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",
            1
        ]
    },
    "+yag[N\u2192N]": {
        "exp": "+yag[N\u2192N]",
        "exp_display": "+yag",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "thing similar to",
        "pluralDefinition": "things similar to",
        "postDefinition": "",
        "description": "thing similar to",
        "match_case": false,
        "keylookup": [
            "+yak",
            0
        ]
    },
    "@~+yarar[N\u2192N]": {
        "exp": "@~+yarar[N\u2192N]",
        "exp_display": "@\u02b8~+yarar",
        "type": "NN",
        "require": "pluralize",
        "singularDefinition": "way of or device dealing with",
        "pluralDefinition": "ways of or devices dealing with",
        "postDefinition": "",
        "description": "way of or device dealing with",
        "match_case": false,
        "keylookup": [
            "@~+yaraq",
            0
        ]
    },
    "\u2013yaya(g)ar*[N\u2192N]": {
        "exp": "\u2013yaya(g)ar*[N\u2192N]",
        "exp_display": "\u2013yaya\u0121ar*",
        "type": "NN",
        "require": "",
        "singularDefinition": "little baby",
        "pluralDefinition": "little baby",
        "postDefinition": "",
        "description": "little baby",
        "match_case": true,
        "keylookup": [
            "-yaya(g)aq*",
            0
        ]
    },
    "@~+ngari[N\u2192V]": {
        "type": "NV",
        "exp": "@~+ngari[N\u2192V]",
        "exp_display": "@\u00b2~+ngari",
        "description": "to seem to be becoming V; to begin to be like N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "beginning to be like",
        "nounNum": "as",
        "present": "begins to be like",
        "was": false,
        "past": "began to be like",
        "inf_prenoun": "begin to be like",
        "ger_prenoun": "beginning to be like",
        "match_case": false,
        "keylookup": [
            "@~+ngari-",
            0
        ]
    },
    "+`(g)ar(ar)[N\u2192V]": {
        "type": "NV",
        "exp": "+`(g)ar(ar)[N\u2192V]",
        "exp_display": "+`(g)ar(ar)",
        "description": "to go only by V-ing or only with N (which is barely adequate for conditions)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "going only with",
        "nounNum": "p",
        "present": "goes only with",
        "was": false,
        "past": "went only with",
        "inf_prenoun": "go only with",
        "ger_prenoun": "going only with",
        "match_case": false,
        "keylookup": [
            "+'(g)ar(ar)-",
            0
        ]
    },
    "+arar(ar)[N\u2192V]": {
        "type": "NV",
        "exp": "+arar(ar)[N\u2192V]",
        "exp_display": "+arar(ar)",
        "description": "to go only by V-ing or only with N (which is barely adequate for conditions)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "going only with",
        "nounNum": "p",
        "present": "goes only with",
        "was": false,
        "past": "went only with",
        "inf_prenoun": "go only with",
        "ger_prenoun": "going only with",
        "match_case": false,
        "keylookup": [
            "+'(g)ar(ar)-",
            1
        ]
    },
    ":(ng)ar(ar)te\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)ar(ar)te\u00b2[N\u2192V]",
        "exp_display": "%:(ng)ar(ar)te",
        "description": "to hit or get hit in or on one\u02bcs N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "got hit on ^its^",
        "nounNum": "p",
        "present": "gets hit on ^its^",
        "was": false,
        "past": "got hit on ^its^",
        "inf_prenoun": "get hit on ^its^",
        "ger_prenoun": "getting hit on ^its^",
        "match_case": false,
        "keylookup": [
            ":(ng)ar(ar)te\u00b2-",
            0
        ]
    },
    "\u2013car(ar)te[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013car(ar)te[N\u2192V]",
        "exp_display": "\u2013car(ar)te",
        "description": "to hit in or on the N, to hit right in or on the N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "got hit on ^its^",
        "nounNum": "p",
        "present": "gets hit on ^its^",
        "was": false,
        "past": "got hit on ^its^",
        "inf_prenoun": "get hit on ^its^",
        "ger_prenoun": "getting hit on ^its^",
        "match_case": false,
        "keylookup": [
            "-car(ar)te-",
            0
        ]
    },
    "+ci[N\u2192V]": {
        "type": "NV",
        "exp": "+ci[N\u2192V]",
        "exp_display": "+ci",
        "description": "to buy (some) N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "buying some",
        "nounNum": "p",
        "present": "buys some",
        "was": false,
        "past": "bought some",
        "inf_prenoun": "buy some",
        "ger_prenoun": "buying some",
        "match_case": false,
        "keylookup": [
            "+ci-",
            0
        ]
    },
    "+cite\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "+cite\u00b2[N\u2192V]",
        "exp_display": "+cite\u00b0",
        "description": "to have the quality of V or N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has the quality of",
        "nounNum": "p",
        "present": "has the quality of",
        "was": false,
        "past": "had the quality of",
        "inf_prenoun": "have the quality of",
        "ger_prenoun": "having the quality of",
        "match_case": false,
        "keylookup": [
            "+cite\u00b2-",
            0
        ]
    },
    "@\u2013ckegg[N\u2192V]": {
        "type": "NV",
        "exp": "@\u2013ckegg[N\u2192V]",
        "exp_display": "@\u2075\u2013ckegg",
        "description": "to be very V, to have good N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has good",
        "nounNum": "p",
        "present": "has good",
        "was": false,
        "past": "had good",
        "inf_prenoun": "have good",
        "ger_prenoun": "having good",
        "match_case": false,
        "keylookup": [
            "@-ckegg-",
            0
        ]
    },
    "+cugninarqe[N\u2192V]": {
        "type": "NV",
        "exp": "+cugninarqe[N\u2192V]",
        "exp_display": "+cugninarqe",
        "description": "(Y form) to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "p",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "+cugninarqe-,+cugnilarqe-,-cugninarqe-",
            0
        ]
    },
    "+cugnilarqe[N\u2192V]": {
        "type": "NV",
        "exp": "+cugnilarqe[N\u2192V]",
        "exp_display": "+cugnilarqe",
        "description": "(NUN, NSU form) to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "p",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "+cugninarqe-,+cugnilarqe-,-cugninarqe-",
            1
        ]
    },
    "\u2013cugninarqe[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013cugninarqe[N\u2192V]",
        "exp_display": "\u2013cugninarqe",
        "description": "(K form) to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "p",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "+cugninarqe-,+cugnilarqe-,-cugninarqe-",
            2
        ]
    },
    "+cugnite[N\u2192V]": {
        "type": "NV",
        "exp": "+cugnite[N\u2192V]",
        "exp_display": "+cugnite\u00b0",
        "description": "to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "p",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "+cugnite-",
            0
        ]
    },
    "\u2013culngu[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013culngu[N\u2192V]",
        "exp_display": "\u2013culngu",
        "description": "to be indisposed with respect to one\u02bcs N; to have trouble V-ing",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "unwell or unwilling with respect to ^its^",
        "nounNum": "p",
        "present": "unwell or unwilling with respect to ^its^",
        "was": true,
        "past": "unwell or unwilling with respect to ^its^",
        "inf_prenoun": "be unwell or unwilling with respect to ^its^",
        "ger_prenoun": "being unwell or unwilling with respect to ^its^",
        "match_case": false,
        "keylookup": [
            "-culngu-",
            0
        ]
    },
    "+cur|+ssur[N\u2192V]": {
        "type": "NV",
        "exp": "+cur|+ssur[N\u2192V]",
        "exp_display": "+c|.ssur",
        "description": "to hunt N; to seek N; to check N (game-catching implement)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "hunting",
        "nounNum": "p",
        "present": "hunts",
        "was": false,
        "past": "hunted",
        "inf_prenoun": "hunt",
        "ger_prenoun": "hunting",
        "match_case": false,
        "keylookup": [
            "+cur-|+ssur-",
            0
        ]
    },
    ":(ng)icag[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)icag[N\u2192V]",
        "exp_display": "%:(ng)icag",
        "description": "to be in need of N; to lack N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "in need of",
        "nounNum": "p",
        "present": "in need of",
        "was": true,
        "past": "in need of",
        "inf_prenoun": "be in need of",
        "ger_prenoun": "being in need of",
        "match_case": false,
        "keylookup": [
            ":(ng)icag-",
            0
        ]
    },
    ":(ng)illiqe[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)illiqe[N\u2192V]",
        "exp_display": "%:(ng)illiqe",
        "description": "to suffer from the lack of N or V",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "suffering from the lack of",
        "nounNum": "p",
        "present": "suffers from the lack of",
        "was": false,
        "past": "suffered from the lack of",
        "inf_prenoun": "suffer from the lack of",
        "ger_prenoun": "suffering from the lack of",
        "match_case": false,
        "keylookup": [
            ":(ng)illiqe-",
            0
        ]
    },
    "\u2013ir\u00b9[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013ir\u00b9[N\u2192V]",
        "exp_display": "\u2013ir",
        "description": "N (natural phenomenon) is occurring; to set N (game capturing device); to provide or be provided with N (but not in the sense of giving N to someone)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "provided with",
        "nounNum": "p",
        "present": "provided with",
        "was": true,
        "past": "provided with",
        "inf_prenoun": "be provided with",
        "ger_prenoun": "being provided with",
        "match_case": false,
        "keylookup": [
            "-ir\u00b9-",
            0
        ]
    },
    ":(ng)ir\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)ir\u00b2[N\u2192V]",
        "exp_display": "%:(ng)ir",
        "description": "to deprive or be deprived of N; to remove N from; to un-V; to pass through the N area of (it)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "deprived of",
        "nounNum": "s",
        "present": "deprived of",
        "was": true,
        "past": "deprived of",
        "inf_prenoun": "be deprived of",
        "ger_prenoun": "being deprived of",
        "match_case": false,
        "keylookup": [
            ":(ng)ir\u00b2-",
            2
        ]
    },
    ":(ng)ir(ar)[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)ir(ar)[N\u2192V]",
        "exp_display": "%:(ng)ir(ar)",
        "description": "to have cold N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has cold",
        "nounNum": "p",
        "present": "has cold",
        "was": false,
        "past": "had cold",
        "inf_prenoun": "have cold",
        "ger_prenoun": "having cold",
        "match_case": false,
        "keylookup": [
            ":(ng)ir(ar)-",
            0
        ]
    },
    ":(ng)ir(ar)te[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)ir(ar)te[N\u2192V]",
        "exp_display": "%:(ng)ir(ar)te",
        "description": "to injure or be injured in one\u02bcs N; to abrubtly cease V-ing",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "injured in ^its^",
        "nounNum": "p",
        "present": "injured in ^its^",
        "was": true,
        "past": "injured in ^its^",
        "inf_prenoun": "be injured in ^its^",
        "ger_prenoun": "being injured in ^its^",
        "match_case": false,
        "keylookup": [
            ":(ng)ir(ar)te-",
            0
        ]
    },
    ":(ng)i:rute[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)i%:rute[N\u2192V]",
        "exp_display": "%:(ng)i%:rute",
        "description": "to not have N any more; to no longer be V (adjectival verbs only)",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "no longer has",
        "nounNum": "p",
        "present": "no longer has",
        "was": false,
        "past": "no longer had",
        "inf_prenoun": "no longer have",
        "ger_prenoun": "no longer having",
        "match_case": false,
        "keylookup": [
            ":(ng)i:rute-",
            0
        ]
    },
    ":(ng)ite\u00b9[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)ite\u00b9[N\u2192V]",
        "exp_display": "%:(ng)ite\u00b0",
        "description": "to lack N or V; to have no N or V",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "lacking",
        "nounNum": "p",
        "present": "lacks",
        "was": false,
        "past": "lacked",
        "inf_prenoun": "lack",
        "ger_prenoun": "lacking",
        "match_case": false,
        "keylookup": [
            ":(ng)ite\u00b9-",
            0
        ]
    },
    "+karci[N\u2192V]": {
        "type": "NV",
        "exp": "+karci[N\u2192V]",
        "exp_display": "+karci",
        "description": "to buy something to serve as one\u02bcs N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "buying something to serve as ^its^",
        "nounNum": "s",
        "present": "buys something to serve as ^its^",
        "was": false,
        "past": "bought something to serve as ^its^",
        "inf_prenoun": "buy something to serve as ^its^",
        "ger_prenoun": "buying something to serve as ^its^",
        "match_case": false,
        "keylookup": [
            "+karci-",
            0
        ]
    },
    "\u2013kegci[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013kegci[N\u2192V]",
        "exp_display": "\u2013kegci",
        "description": "to have good N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has good",
        "nounNum": "p",
        "present": "has good",
        "was": false,
        "past": "had good",
        "inf_prenoun": "have good",
        "ger_prenoun": "having good",
        "match_case": false,
        "keylookup": [
            "-kegci-",
            1
        ]
    },
    "\u2013kegte[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013kegte[N\u2192V]",
        "exp_display": "\u2013k\u0332egte",
        "description": "to be good N; to have good N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has good",
        "nounNum": "p",
        "present": "has good",
        "was": false,
        "past": "had good",
        "inf_prenoun": "have good",
        "ger_prenoun": "having good",
        "match_case": false,
        "keylookup": [
            "-kegte-",
            0
        ]
    },
    "\u2013kiirar[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013kiirar[N\u2192V]",
        "exp_display": "\u2013kiirar",
        "description": "to be in (water, mud, tall grass, body part, etc.) up to one\u02bcs N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "nounNum": "s",
        "present": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "was": true,
        "past": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "inf_prenoun": "be in (water, mud, tall grass, body part, etc.) up to ^its^",
        "ger_prenoun": "being in (water, mud, tall grass, body part, etc.) up to ^its^",
        "match_case": false,
        "keylookup": [
            "-kiirar-,-kiir(ar)-,-kaar-",
            0
        ]
    },
    "\u2013kiir(ar)[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013kiir(ar)[N\u2192V]",
        "exp_display": "\u2013kiir(ar)",
        "description": "to be in (water, mud, tall grass, body part, etc.) up to one\u02bcs N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "nounNum": "s",
        "present": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "was": true,
        "past": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "inf_prenoun": "be in (water, mud, tall grass, body part, etc.) up to ^its^",
        "ger_prenoun": "being in (water, mud, tall grass, body part, etc.) up to ^its^",
        "match_case": false,
        "keylookup": [
            "-kiirar-,-kiir(ar)-,-kaar-",
            1
        ]
    },
    "\u2013kaar[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013kaar[N\u2192V]",
        "exp_display": "\u2013kaar",
        "description": "to be in (water, mud, tall grass, body part, etc.) up to one\u02bcs N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "nounNum": "s",
        "present": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "was": true,
        "past": "in (water, mud, tall grass, body part, etc.) up to ^its^",
        "inf_prenoun": "be in (water, mud, tall grass, body part, etc.) up to ^its^",
        "ger_prenoun": "being in (water, mud, tall grass, body part, etc.) up to ^its^",
        "match_case": false,
        "keylookup": [
            "-kiirar-,-kiir(ar)-,-kaar-",
            2
        ]
    },
    "+kiur[N\u2192V]": {
        "type": "NV",
        "exp": "+kiur[N\u2192V]",
        "exp_display": "+kiur",
        "description": "to prepare something to be N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "preparing something to be",
        "nounNum": "s",
        "present": "prepares something to be",
        "was": false,
        "past": "prepared something to be",
        "inf_prenoun": "prepare something to be",
        "ger_prenoun": "preparing something to be",
        "match_case": false,
        "keylookup": [
            "+kiur-",
            0
        ]
    },
    "\u2013knaggairute[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013knaggairute[N\u2192V]",
        "exp_display": "\u2013knaggairute",
        "description": "to have come to totally lack N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has come to totally lack",
        "nounNum": "p",
        "present": "has come to totally lack",
        "was": false,
        "past": "had come to totally lack",
        "inf_prenoun": "have come to totally lack",
        "ger_prenoun": "having come to totally lack",
        "match_case": false,
        "keylookup": [
            "-knaggairute-",
            0
        ]
    },
    "\u2013knaggaite[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013knaggaite[N\u2192V]",
        "exp_display": "\u2013knaggaite",
        "description": "to totally lack N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "totally lacks",
        "nounNum": "p",
        "present": "totally lacks",
        "was": false,
        "past": "totally lacked",
        "inf_prenoun": "totally lack",
        "ger_prenoun": "totally lacking",
        "match_case": false,
        "keylookup": [
            "-knaggaite-",
            0
        ]
    },
    "%kuir[N\u2192V]": {
        "type": "NV",
        "exp": "%%kuir[N\u2192V]",
        "exp_display": "%%kuir",
        "description": "to go along N; to go following N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "going along",
        "nounNum": "s",
        "present": "goes along",
        "was": false,
        "past": "went along",
        "inf_prenoun": "go along",
        "ger_prenoun": "going along",
        "match_case": false,
        "keylookup": [
            "%kuir-",
            0
        ]
    },
    "\u2013laar(ar)[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013laar(ar)[N\u2192V]",
        "exp_display": "\u2013laar(ar)",
        "description": "to get a new N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "getting new",
        "nounNum": "p",
        "present": "gets new",
        "was": false,
        "past": "got new",
        "inf_prenoun": "get new",
        "ger_prenoun": "getting new",
        "match_case": false,
        "keylookup": [
            "-laar(ar)-",
            0
        ]
    },
    "\u2013lgir[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013lgir[N\u2192V]",
        "exp_display": "\u2013lgir",
        "description": "to take along N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "taking along",
        "nounNum": "p",
        "present": "takes along",
        "was": false,
        "past": "took along",
        "inf_prenoun": "take along",
        "ger_prenoun": "taking along",
        "match_case": false,
        "keylookup": [
            "-lgir-",
            0
        ]
    },
    "\u2013\u2013li\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013li\u00b2[N\u2192V]",
        "exp_display": "\u2013\u2013li",
        "description": "to make N; to make N for (him); to make N out of (it)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "making",
        "nounNum": "as",
        "present": "makes",
        "was": false,
        "past": "made",
        "inf_prenoun": "make",
        "ger_prenoun": "making",
        "match_case": false,
        "keylookup": [
            "-li\u00b2-",
            0
        ]
    },
    "\u2013\u2013linqigte[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013linqigte[N\u2192V]",
        "exp_display": "\u2013\u2013linqigte",
        "description": "to change one\u02bcs N; to get another N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "changing ^its^",
        "nounNum": "p",
        "present": "changes ^its^",
        "was": false,
        "past": "changed ^its^",
        "inf_prenoun": "change ^its^",
        "ger_prenoun": "changing ^its^",
        "match_case": false,
        "keylookup": [
            "-linqigte-",
            0
        ]
    },
    "\u2013\u2013liqe\u00b9[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013liqe\u00b9[N\u2192V]",
        "exp_display": "\u2013\u2013liqe",
        "description": "to catch a lot of N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "catching a lot of",
        "nounNum": "p",
        "present": "catches a lot of",
        "was": false,
        "past": "caught a lot of",
        "inf_prenoun": "catch a lot of",
        "ger_prenoun": "catching a lot of",
        "match_case": false,
        "keylookup": [
            "-liqe\u00b9-",
            0
        ]
    },
    "\u2013\u2013liqe\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013liqe\u00b2[N\u2192V]",
        "exp_display": "\u2013\u2013liqe",
        "description": "to be afflicted in one\u02bcs N or with respect to N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "afflicted in ^its^",
        "nounNum": "s",
        "present": "afflicted in ^its^",
        "was": true,
        "past": "afflicted in ^its^",
        "inf_prenoun": "be afflicted in ^its^",
        "ger_prenoun": "being afflicted in ^its^",
        "match_case": false,
        "keylookup": [
            "-liqe\u00b2-",
            0
        ]
    },
    "\u2013\u2013lir[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013lir[N\u2192V]",
        "exp_display": "\u2013\u2013lir",
        "description": "to have lots of N; to provide with or be well provided with N; to add N to (it)",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has lots of",
        "nounNum": "p",
        "present": "has lots of",
        "was": false,
        "past": "had lots of",
        "inf_prenoun": "have lots of",
        "ger_prenoun": "having lots of",
        "match_case": false,
        "keylookup": [
            "-lir-",
            0
        ]
    },
    "\u2013\u2013liur[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013liur[N\u2192V]",
        "exp_display": "\u2013\u2013liur",
        "description": "to be occupied with N; to work or play with N; to cook N (additional NUN meaning)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "occupied with",
        "nounNum": "p",
        "present": "occupied with",
        "was": true,
        "past": "occupied with",
        "inf_prenoun": "be occupied with",
        "ger_prenoun": "being occupied with",
        "match_case": false,
        "keylookup": [
            "-liur-",
            0
        ]
    },
    "\u2013\u2013liyar[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013\u2013liyar[N\u2192V]",
        "exp_display": "\u2013\u2013liyar",
        "description": "to go to participate in N or V",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "going to participate in",
        "nounNum": "s",
        "present": "goes to participate in",
        "was": false,
        "past": "went to participate in",
        "inf_prenoun": "go to participate in",
        "ger_prenoun": "going to participate in",
        "match_case": false,
        "keylookup": [
            "-liyar-,-liar-",
            0
        ]
    },
    "\u2013liar[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013liar[N\u2192V]",
        "exp_display": "\u2013liar",
        "description": "to go to participate in N or V",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "going to participate in",
        "nounNum": "s",
        "present": "goes to participate in",
        "was": false,
        "past": "went to participate in",
        "inf_prenoun": "go to participate in",
        "ger_prenoun": "going to participate in",
        "match_case": false,
        "keylookup": [
            "-liyar-,-liar-",
            1
        ]
    },
    "\u2013lkia[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013lkia[N\u2192V]",
        "exp_display": "\u2013lkia",
        "description": "to give evidence or indication of N or V",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "giving evidence of",
        "nounNum": "p",
        "present": "gives evidence of",
        "was": false,
        "past": "gave evidence of",
        "inf_prenoun": "give evidence of",
        "ger_prenoun": "giving evidence of",
        "match_case": false,
        "keylookup": [
            "-lkia-",
            0
        ]
    },
    "\u2013lkite[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013lkite[N\u2192V]",
        "exp_display": "\u2013lkite",
        "description": "to make a noise or give other evidence of N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "giving evidence of",
        "nounNum": "p",
        "present": "gives evidence of",
        "was": false,
        "past": "gave evidence of",
        "inf_prenoun": "give evidence of",
        "ger_prenoun": "giving evidence of",
        "match_case": false,
        "keylookup": [
            "-lkite-",
            0
        ]
    },
    "+lliqe[N\u2192V]": {
        "type": "NV",
        "exp": "+lliqe[N\u2192V]",
        "exp_display": "+lliqe",
        "description": "to have N of poor quality",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has poor quality",
        "nounNum": "p",
        "present": "has poor quality",
        "was": false,
        "past": "had poor quality",
        "inf_prenoun": "have poor quality",
        "ger_prenoun": "having poor quality",
        "match_case": false,
        "keylookup": [
            "+lliqe-",
            0
        ]
    },
    "\u2013llug[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013llug[N\u2192V]",
        "exp_display": "\u2013llug",
        "description": "to have bad N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has bad",
        "nounNum": "p",
        "present": "has bad",
        "was": false,
        "past": "had bad",
        "inf_prenoun": "have bad",
        "ger_prenoun": "having bad",
        "match_case": false,
        "keylookup": [
            "@-lluk,-llug-,-llugte-",
            1
        ]
    },
    "\u2013llugte[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013llugte[N\u2192V]",
        "exp_display": "\u2013llugte",
        "description": "to have bad N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has bad",
        "nounNum": "p",
        "present": "has bad",
        "was": false,
        "past": "had bad",
        "inf_prenoun": "have bad",
        "ger_prenoun": "having bad",
        "match_case": false,
        "keylookup": [
            "@-lluk,-llug-,-llugte-",
            2
        ]
    },
    "+mig[N\u2192V]": {
        "type": "NV",
        "exp": "+mig[N\u2192V]",
        "exp_display": "+mig",
        "description": "to put in one\u02bcs N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "putting something in ^its^",
        "nounNum": "s",
        "present": "puts something in ^its^",
        "was": false,
        "past": "put something in ^its^",
        "inf_prenoun": "put something in ^its^",
        "ger_prenoun": "putting something in ^its^",
        "match_case": false,
        "keylookup": [
            "+mik,+miaq,+mig-",
            2
        ]
    },
    "+miu[N\u2192V]": {
        "type": "NV",
        "exp": "+miu[N\u2192V]",
        "exp_display": "+miu",
        "description": "to be at N; to stay at N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "at",
        "nounNum": "s",
        "present": "at",
        "was": true,
        "past": "at",
        "inf_prenoun": "be at",
        "ger_prenoun": "being at",
        "match_case": false,
        "keylookup": [
            "+miu-",
            0
        ]
    },
    "+miuyaar[N\u2192V]": {
        "type": "NV",
        "exp": "+miuyaar[N\u2192V]",
        "exp_display": "+miuyaar",
        "description": "to speak the language or dialect of the residents of N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "speaks the language or dialect of the residents of",
        "nounNum": "s",
        "present": "speaks the language or dialect of the residents of",
        "was": false,
        "past": "spoke the language or dialect of the residents of",
        "inf_prenoun": "speak the language or dialect of the residents of",
        "ger_prenoun": "speaking the language or dialect of the residents of",
        "match_case": false,
        "keylookup": [
            "+miuyaar-",
            0
        ]
    },
    "+ngate[N\u2192V]": {
        "type": "NV",
        "exp": "+ngate[N\u2192V]",
        "exp_display": "+(r)ngate\u00b0",
        "description": "to seem like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "seems like",
        "nounNum": "as",
        "present": "seems like",
        "was": false,
        "past": "seemed like",
        "inf_prenoun": "seem like",
        "ger_prenoun": "seeming like",
        "match_case": false,
        "keylookup": [
            "@~+ngate-,+ngate-",
            0
        ]
    },
    "\u2013nge[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013nge[N\u2192V]",
        "exp_display": "\u2013nge",
        "description": "to acquire N; to begin to V",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has acquired",
        "nounNum": "as",
        "present": "has acquired",
        "was": false,
        "past": "had acquired",
        "inf_prenoun": "have acquired",
        "ger_prenoun": "having acquired",
        "match_case": false,
        "keylookup": [
            "-nge-",
            0
        ]
    },
    "\u2013ngqerr[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013ngqerr[N\u2192V]",
        "exp_display": "\u2013ngqerr",
        "description": "to have N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has",
        "nounNum": "as",
        "present": "has",
        "was": false,
        "past": "had",
        "inf_prenoun": "have",
        "ger_prenoun": "having",
        "match_case": false,
        "keylookup": [
            "-ngqerr-",
            1
        ]
    },
    "@~+nialke[N\u2192V]": {
        "type": "NV",
        "exp": "@~+nialke[N\u2192V]",
        "exp_display": "@\u00b9~+nialke",
        "description": "to consider object to be unpleasant to V or to be an unpleasant N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "considers it to be an unpleasant",
        "nounNum": "s",
        "present": "considers it to be an unpleasant",
        "was": false,
        "past": "considered it to be an unpleasant",
        "inf_prenoun": "consider it to be an unpleasant",
        "ger_prenoun": "considering it to be an unpleasant",
        "match_case": false,
        "keylookup": [
            "@~+nialke-",
            0
        ]
    },
    "@~+niate[N\u2192V]": {
        "type": "NV",
        "exp": "@~+niate[N\u2192V]",
        "exp_display": "@\u00b9~+niate",
        "description": "to be unpleasant to V; to be an unpleasant N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "an unpleasant",
        "nounNum": "s",
        "present": "an unpleasant",
        "was": true,
        "past": "an unpleasant",
        "inf_prenoun": "be an unpleasant",
        "ger_prenoun": "being an unpleasant",
        "match_case": false,
        "keylookup": [
            "@~+niate-",
            0
        ]
    },
    "@~+niilke[N\u2192V]": {
        "type": "NV",
        "exp": "@~+niilke[N\u2192V]",
        "exp_display": "@\u00b9~+niilke",
        "description": "to consider object to be unpleasant to V or to be an unpleasant N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "considers it to be an unpleasant",
        "nounNum": "s",
        "present": "considers it to be an unpleasant",
        "was": false,
        "past": "considered it to be an unpleasant",
        "inf_prenoun": "consider it to be an unpleasant",
        "ger_prenoun": "considering it to be an unpleasant",
        "match_case": false,
        "keylookup": [
            "@~+niilke-",
            0
        ]
    },
    "@~+niite[N\u2192V]": {
        "type": "NV",
        "exp": "@~+niite[N\u2192V]",
        "exp_display": "@\u00b9~+niite",
        "description": "to be unpleasant to V; to be an unpleasant N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "an unpleasant",
        "nounNum": "s",
        "present": "an unpleasant",
        "was": true,
        "past": "an unpleasant",
        "inf_prenoun": "be an unpleasant",
        "ger_prenoun": "being an unpleasant",
        "match_case": false,
        "keylookup": [
            "@~+niite-",
            0
        ]
    },
    "@~+nike[N\u2192V]": {
        "type": "NV",
        "exp": "@~+nike[N\u2192V]",
        "exp_display": "@\u00b9~+nike",
        "description": "to consider object to be pleasant to V or to be a pleasant N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "considers it to be an unpleasant",
        "nounNum": "s",
        "present": "considers it to be an unpleasant",
        "was": false,
        "past": "considered it to be an unpleasant",
        "inf_prenoun": "consider it to be an unpleasant",
        "ger_prenoun": "considering it to be an unpleasant",
        "match_case": false,
        "keylookup": [
            "@~+nike-",
            0
        ]
    },
    "~+ninarqe[N\u2192V]": {
        "type": "NV",
        "exp": "~+ninarqe[N\u2192V]",
        "exp_display": "~+ninarqe",
        "description": "to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "s",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "~+ninarqe-,~+nilarqe-",
            0
        ]
    },
    "~+nilarqe[N\u2192V]": {
        "type": "NV",
        "exp": "~+nilarqe[N\u2192V]",
        "exp_display": "~+nilarqe",
        "description": "(NUN, NSU form) to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "s",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "~+ninarqe-,~+nilarqe-",
            1
        ]
    },
    "@~+nirqe[N\u2192V]": {
        "type": "NV",
        "exp": "@~+nirqe[N\u2192V]",
        "exp_display": "@\u00b9~+nirqe",
        "description": "to be pleasant to V; to be a pleasant N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "a pleasant",
        "nounNum": "s",
        "present": "a pleasant",
        "was": true,
        "past": "a pleasant",
        "inf_prenoun": "be a pleasant",
        "ger_prenoun": "being a pleasant",
        "match_case": false,
        "keylookup": [
            "@~+nirqe-",
            0
        ]
    },
    "+nite[N\u2192V]": {
        "type": "NV",
        "exp": "+nite[N\u2192V]",
        "exp_display": "+nite\u00b0",
        "description": "to smell or taste like N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes like",
        "nounNum": "s",
        "present": "smells or tastes like",
        "was": false,
        "past": "smelled or tasted like",
        "inf_prenoun": "smell or taste like",
        "ger_prenoun": "smelling or tasting like",
        "match_case": false,
        "keylookup": [
            "+nite-",
            0
        ]
    },
    "\u2013qsig[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013qsig[N\u2192V]",
        "exp_display": "\u2013q\u0332sig",
        "description": "to be far in the direction denoted by N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "far in the direction denoted by",
        "nounNum": "s",
        "present": "far in the direction denoted by",
        "was": true,
        "past": "far in the direction denoted by",
        "inf_prenoun": "be far in the direction denoted by",
        "ger_prenoun": "being far in the direction denoted by",
        "match_case": false,
        "keylookup": [
            "-qsig-",
            2
        ]
    },
    "\u2013qsigi[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013qsigi[N\u2192V]",
        "exp_display": "\u2013q\u0332sigi",
        "description": "to get farther into the area denoted by N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "getting farther in the direction denoted by",
        "nounNum": "s",
        "present": "goes farther in the direction denoted by",
        "was": false,
        "past": "went farther in the direction denoted by",
        "inf_prenoun": "go farther in the direction denoted by",
        "ger_prenoun": "going farther in the direction denoted by",
        "match_case": false,
        "keylookup": [
            "-qsigi-",
            2
        ]
    },
    "\u2013qu\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013qu\u00b2[N\u2192V]",
        "exp_display": "\u2013qu",
        "description": "to hunt with N or at N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "hunting with or at",
        "nounNum": "s",
        "present": "hunts with or at",
        "was": false,
        "past": "hunted with or at",
        "inf_prenoun": "hunt with or at",
        "ger_prenoun": "hunting with or at",
        "match_case": false,
        "keylookup": [
            "-qu\u00b2-",
            0
        ]
    },
    "\u2013rpagninarqe[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013rpagninarqe[N\u2192V]",
        "exp_display": "\u2013r\u0332pagninarqe",
        "description": "to smell strongly of N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells strongly of",
        "nounNum": "s",
        "present": "smells strongly of",
        "was": false,
        "past": "smelled strongly of",
        "inf_prenoun": "smell strongly of",
        "ger_prenoun": "smelling strongly of",
        "match_case": false,
        "keylookup": [
            "-rpagninarqe-",
            0
        ]
    },
    "\u2013rpagnite[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013rpagnite[N\u2192V]",
        "exp_display": "\u2013r\u0332pagnite",
        "description": "to smell or taste strongly of N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "smells or tastes strongly of",
        "nounNum": "s",
        "present": "smells or tastes strongly of",
        "was": false,
        "past": "smelled or tasted strongly of",
        "inf_prenoun": "smell or taste strongly of",
        "ger_prenoun": "smelling or tasting strongly of",
        "match_case": false,
        "keylookup": [
            "-rpagnite-",
            0
        ]
    },
    "\u2013rpau[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013rpau[N\u2192V]",
        "exp_display": "\u2013r\u0332pau",
        "description": "to be a large N; to have a large N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "a large",
        "nounNum": "s",
        "present": "a large",
        "was": true,
        "past": "a large",
        "inf_prenoun": "be a large",
        "ger_prenoun": "being a large",
        "match_case": false,
        "keylookup": [
            "-rpau-",
            0
        ]
    },
    "\u2013rpi[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013rpi[N\u2192V]",
        "exp_display": "\u2013r\u0332pi",
        "description": "to have a large N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has a large",
        "nounNum": "s",
        "present": "has a large",
        "was": false,
        "past": "had a large",
        "inf_prenoun": "have a large",
        "ger_prenoun": "having a large",
        "match_case": false,
        "keylookup": [
            "-rpi-",
            0
        ]
    },
    "\u2013rrlug[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013rrlug[N\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332lug",
        "description": "to be dirtied with N; to be somewhat V; to be afflicted in one\u02bcs N or in respect to N; to have bad N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "dirtied with",
        "nounNum": "p",
        "present": "dirtied with",
        "was": true,
        "past": "dirtied with",
        "inf_prenoun": "be dirtied with",
        "ger_prenoun": "being dirtied with",
        "match_case": false,
        "keylookup": [
            "-rrluk,-rrlug-,-rrlugte-",
            1
        ]
    },
    "\u2013rrlugte[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013rrlugte[N\u2192V]",
        "exp_display": "\u2013r\u0332r\u0332lugte",
        "description": "to be dirtied with N; to be somewhat V; to be afflicted in one\u02bcs N or in respect to N; to have bad N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "dirtied with",
        "nounNum": "p",
        "present": "dirtied with",
        "was": true,
        "past": "dirtied with",
        "inf_prenoun": "be dirtied with",
        "ger_prenoun": "being dirtied with",
        "match_case": false,
        "keylookup": [
            "-rrluk,-rrlug-,-rrlugte-",
            2
        ]
    },
    "\u2013(u)saar[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013(u)saar[N\u2192V]",
        "exp_display": "\u2013(u)saar",
        "description": "to speak the language of N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "speaks the language of",
        "nounNum": "s",
        "present": "speaks the language of",
        "was": false,
        "past": "spoke the language of",
        "inf_prenoun": "speak the language of",
        "ger_prenoun": "speaking the language of",
        "match_case": false,
        "keylookup": [
            "-(u)saar-",
            0
        ]
    },
    "\u2013ssaag\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013ssaag\u00b2[N\u2192V]",
        "exp_display": "\u2013ssaag",
        "description": "to fetch some N from an easily accessible place",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "fetched (from an easily accessible place) some",
        "nounNum": "p",
        "present": "fetches (from an easily accessible place) some",
        "was": false,
        "past": "fetched (from an easily accessible place) some",
        "inf_prenoun": "fetch (from an easily accessible place) some",
        "ger_prenoun": "fetching (from an easily accessible place) some",
        "match_case": false,
        "keylookup": [
            "-ssaag\u00b2-",
            0
        ]
    },
    "\u2013ssaar[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013ssaar[N\u2192V]",
        "exp_display": "\u2013ssaar",
        "description": "to hunt N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "hunting",
        "nounNum": "p",
        "present": "hunts",
        "was": false,
        "past": "hunted",
        "inf_prenoun": "hunt",
        "ger_prenoun": "hunting",
        "match_case": false,
        "keylookup": [
            "-ssaar-",
            0
        ]
    },
    "+ssur[N\u2192V]": {
        "type": "NV",
        "exp": "+ssur[N\u2192V]",
        "exp_display": "+ssur",
        "description": "to hunt N; to seek N; to check N (game-capturing implement)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "hunting",
        "nounNum": "p",
        "present": "hunts",
        "was": false,
        "past": "hunted",
        "inf_prenoun": "hunt",
        "ger_prenoun": "hunting",
        "match_case": false,
        "keylookup": [
            "+ssur-",
            0
        ]
    },
    "+tairute[N\u2192V]": {
        "type": "NV",
        "exp": "+tairute[N\u2192V]",
        "exp_display": "+tairute",
        "description": "(for there) to be no more N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has no more",
        "nounNum": "p",
        "present": "has no more",
        "was": false,
        "past": "had no more",
        "inf_prenoun": "have no more",
        "ger_prenoun": "having no more",
        "match_case": false,
        "keylookup": [
            "+tairute-",
            0
        ]
    },
    "+taite\u00b9[N\u2192V]": {
        "type": "NV",
        "exp": "+taite\u00b9[N\u2192V]",
        "exp_display": "+taite\u00b0",
        "description": "(for there) to be no N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has no",
        "nounNum": "p",
        "present": "has no",
        "was": false,
        "past": "had no",
        "inf_prenoun": "have no",
        "ger_prenoun": "having no",
        "match_case": false,
        "keylookup": [
            "+taite\u00b9-",
            0
        ]
    },
    "+taknaggaite[N\u2192V]": {
        "type": "NV",
        "exp": "+taknaggaite[N\u2192V]",
        "exp_display": "+taknaggaite",
        "description": "for there to be absolutely no N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has absolutely no",
        "nounNum": "p",
        "present": "has absolutely no",
        "was": false,
        "past": "had absolutely no",
        "inf_prenoun": "have absolutely no",
        "ger_prenoun": "having absolutely no",
        "match_case": false,
        "keylookup": [
            "+taknaggaite-",
            0
        ]
    },
    "+tange[N\u2192V]": {
        "type": "NV",
        "exp": "+tange[N\u2192V]",
        "exp_display": "+tange",
        "description": "(for there) to be N now",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "now has",
        "nounNum": "as",
        "present": "now has",
        "was": false,
        "past": "now had",
        "inf_prenoun": "now have",
        "ger_prenoun": "now having",
        "match_case": false,
        "keylookup": [
            "+tange-",
            0
        ]
    },
    "+tangqerr[N\u2192V]": {
        "type": "NV",
        "exp": "+tangqerr[N\u2192V]",
        "exp_display": "+tangqerr",
        "description": "(for there) to be N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has",
        "nounNum": "as",
        "present": "has",
        "was": false,
        "past": "had",
        "inf_prenoun": "have",
        "ger_prenoun": "having",
        "match_case": false,
        "keylookup": [
            "+tangqerr-",
            0
        ]
    },
    "+tar\u00b3[N\u2192V]": {
        "type": "NV",
        "exp": "+tar\u00b3[N\u2192V]",
        "exp_display": "+tar",
        "description": "(for there) to be N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has",
        "nounNum": "as",
        "present": "has",
        "was": false,
        "past": "had",
        "inf_prenoun": "have",
        "ger_prenoun": "having",
        "match_case": false,
        "keylookup": [
            "+tar\u00b3-",
            0
        ]
    },
    "+te\u00b9[N\u2192V]": {
        "type": "NV",
        "exp": "+te\u00b9[N\u2192V]",
        "exp_display": "+te",
        "description": "to catch N (game animal); to go to N (place); to obtain N; to spend the N (time); for N (time) to pass",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "caught, went to",
        "nounNum": "as",
        "present": "catches, goes to",
        "was": false,
        "past": "caught, went to",
        "inf_prenoun": "catch, go to",
        "ger_prenoun": "catching, going to",
        "match_case": false,
        "keylookup": [
            "+te\u00b9-",
            0
        ]
    },
    "+te\u2076[N\u2192V]": {
        "type": "NV",
        "exp": "+te\u2076[N\u2192V]",
        "exp_display": "+te",
        "description": "to make the N noise",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "making a noise like",
        "nounNum": "as",
        "present": "makes a noise like",
        "was": false,
        "past": "made a noise like",
        "inf_prenoun": "make a noise like",
        "ger_prenoun": "making a noise like",
        "match_case": false,
        "keylookup": [
            "+te\u2076-",
            0
        ]
    },
    "\u2013tmurte\u00b9[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013tmurte\u00b9[N\u2192V]",
        "exp_display": "\u2013tmurte",
        "description": "to go N-ward; to go in the area described by V",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "going toward the direction of",
        "nounNum": "s",
        "present": "goes toward the direction of",
        "was": false,
        "past": "went toward the direction of",
        "inf_prenoun": "go toward the direction of",
        "ger_prenoun": "going toward the direction of",
        "match_case": false,
        "keylookup": [
            "-tmurte\u00b9-",
            0
        ]
    },
    "\u2013trute[N\u2192V]": {
        "type": "NV",
        "exp": "\u2013trute[N\u2192V]",
        "exp_display": "\u2013trute",
        "description": "to miss by passing through the N area, or the N area of it",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "missed by passing through the area of",
        "nounNum": "s",
        "present": "misses by passing through the area of",
        "was": false,
        "past": "missed by passing through the area of",
        "inf_prenoun": "miss by passing through the area of",
        "ger_prenoun": "missing by passing through the area of",
        "match_case": false,
        "keylookup": [
            "-trute-",
            0
        ]
    },
    "+tu[N\u2192V]": {
        "type": "NV",
        "exp": "+tu[N\u2192V]",
        "exp_display": "+tu",
        "description": "to be well endowed with N, to have N to a large extent",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "well endowed with",
        "nounNum": "s",
        "present": "well endowed with",
        "was": true,
        "past": "well endowed with",
        "inf_prenoun": "be well endowed with",
        "ger_prenoun": "being well endowed with",
        "match_case": false,
        "keylookup": [
            "+tu-,-tu-",
            2
        ]
    },
    "+tur\u00b2[N\u2192V]": {
        "type": "NV",
        "exp": "+tur\u00b2[N\u2192V]",
        "exp_display": "+tur",
        "description": "to eat N (food); to wear N (clothing); to use N (limited usage with this meaning)",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "eating (food), wearing (clothing), using",
        "nounNum": "s",
        "present": "eats (food), wears (clothing), uses",
        "was": false,
        "past": "ate (food), wore (clothing), used",
        "inf_prenoun": "eat (food), wear (clothing), use",
        "ger_prenoun": "eating (food), wearing (clothing), using",
        "match_case": false,
        "keylookup": [
            "+tur\u00b2-",
            0
        ]
    },
    "+(r)tuuma(r)[N\u2192V]": {
        "type": "NV",
        "exp": "+(r)tuuma(r)[N\u2192V]",
        "exp_display": "+(r)tuumar",
        "description": "to act together with one\u02bcs N or Ns",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "acting together with ^its^",
        "nounNum": "s",
        "present": "acts together with ^its^",
        "was": false,
        "past": "acted together with ^its^",
        "inf_prenoun": "act together with ^its^",
        "ger_prenoun": "acting together with ^its^",
        "match_case": false,
        "keylookup": [
            "+(r)tuuma(r)-",
            1
        ]
    },
    ":~(ng)u[N\u2192V]": {
        "type": "NV",
        "exp": "%:~(ng)u[N\u2192V]",
        "exp_display": "%:~(ng)u",
        "description": "to be N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "",
        "nounNum": "as",
        "present": "",
        "was": true,
        "past": "",
        "inf_prenoun": "be",
        "ger_prenoun": "being",
        "match_case": false,
        "keylookup": [
            ":~(ng)u-",
            0
        ]
    },
    ":(ng)ucir[N\u2192V]": {
        "type": "NV",
        "exp": "%:(ng)ucir[N\u2192V]",
        "exp_display": "%:(ng)ucir",
        "description": "to have lots of N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has lots of",
        "nounNum": "s",
        "present": "has lots of",
        "was": false,
        "past": "had lots of",
        "inf_prenoun": "have lots of",
        "ger_prenoun": "having lots of",
        "match_case": false,
        "keylookup": [
            ":(ng)ucir-",
            0
        ]
    },
    ":~(ng)urte[N\u2192V]": {
        "type": "NV",
        "exp": "%:~(ng)urte[N\u2192V]",
        "exp_display": "%:~(ng)urte",
        "description": "to become N; to expose the N of (it)",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "became",
        "nounNum": "as",
        "present": "becomes",
        "was": false,
        "past": "became",
        "inf_prenoun": "become",
        "ger_prenoun": "becoming",
        "match_case": false,
        "keylookup": [
            ":~(ng)urte-",
            0
        ]
    },
    "+yag[N\u2192V]": {
        "type": "NV",
        "exp": "+yag[N\u2192V]",
        "exp_display": "+yag",
        "description": "(for there) to be much N, many N",
        "subjectit": "it",
        "is": false,
        "gen_prenoun": "has many",
        "nounNum": "p",
        "present": "has many",
        "was": false,
        "past": "had many",
        "inf_prenoun": "have many",
        "ger_prenoun": "having many",
        "match_case": false,
        "keylookup": [
            "+yag-",
            0
        ]
    },
    "+(r)yug[N\u2192V]": {
        "type": "NV",
        "exp": "+(r)yug[N\u2192V]",
        "exp_display": "+(r)yug",
        "description": "to want N; to want to do the appropriate thing with N",
        "subjectit": "it",
        "is": true,
        "gen_prenoun": "wanting",
        "nounNum": "p",
        "present": "wants",
        "was": false,
        "past": "wanted",
        "inf_prenoun": "want",
        "ger_prenoun": "wanting",
        "match_case": false,
        "keylookup": [
            "@~+yug-,+(r)yug-",
            0
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/constants/newpostbases.js